var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAspNetLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 205,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 15 L 88.5 15 L 90 16.5 L 88.5 19 L 87 18.5 Q 89.3 17.3 86.5 16 Q 84.3 15.3 85 17.5 L 85.5 19 Q 84.8 16.2 80.5 17 L 79 17.5 L 80.5 15 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 15 Q 135.5 13.5 135 16.5 L 138 17.5 L 135.5 18 L 133.5 17 L 130.5 19 L 129.5 16 L 128.5 15 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 15 Q 196.7 13.9 195 18 L 191 16.5 L 192.5 15 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 15 L 224 15.5 L 216.5 16 L 212.5 18 L 208.5 16 L 209.5 19 L 206.5 18 L 206.5 20 Q 204.3 20.8 205 18.5 L 208.5 15 Z M 213 16 L 213 17 L 215 17 L 213 16 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 15 L 232 15.5 L 226.5 16 L 226.5 15 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 16 L 69 16.5 L 64 18 L 64 16 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 16 L 98 19 L 91.5 20 L 91.5 19 L 97 18 L 97.5 16 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 16 L 105 17.5 Q 103.8 20 100 19 L 101.5 16 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 16 L 146 17.5 L 144.5 17 L 143.5 16 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 16 L 242 16.5 L 238.5 18 L 238.5 17 L 240.5 16 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 17 L 129 19 L 127 18.5 L 128.5 17 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 17 L 224 17.5 L 220.5 18 L 220.5 17 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 18 L 115 18.5 L 112.5 19 L 112.5 18 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120 18 L 125 18.5 Q 123.7 21.3 122.5 19 L 120.5 20 L 120 18 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 19 L 204 19.5 L 201.5 23 L 199.5 24 L 201 21.5 L 200.5 20 L 196.5 23 L 196 21.5 L 199.5 19 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154 21 L 158 21 L 158 22.5 L 154 24 L 154 21 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 22 L 75 22.5 L 72 23.5 L 72.5 25 L 69 23.5 L 71.5 22 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 24 L 68 25.5 L 66.5 30 L 65 26.5 L 67.5 24 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 24 L 160 29.5 L 159 29.5 L 156 25.5 L 158 25 L 158.5 27 L 159.5 24 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69 27 L 71 27.5 L 69 28.5 L 69 27 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 27 L 256 30.5 L 254 31.5 L 255 29.5 L 254.5 27 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 28 L 193.5 30 L 194.5 28 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 31 L 51 32.5 Q 51.8 36.3 49.5 37 Q 47.3 37.8 48 35.5 L 47 32.5 L 48.5 31 Z M 48 32 Q 47 36 50 35 Q 51 31 48 32 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 31 L 163 32 L 163 37 L 161 37 L 159 33.5 L 159.5 31 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 31 L 192 33.5 L 191 33.5 L 190.5 32 L 189 32.5 L 190.5 31 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 32 L 64.5 34 L 65 32 L 67 32.5 L 63 35 L 63.5 32 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172 32 L 176 32.5 L 174.5 36 L 172 35.5 L 172 32 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179 32 L 183 33.5 L 182 36 Q 184.7 34.9 184 37.5 Q 186 35.8 188 39.5 L 186 40.5 L 187 44.5 L 185 44.5 L 183.5 48 L 183 39.5 L 184 38.5 L 180.5 35 Q 177.5 35.7 179 32 Z M 185 41 L 184 44 L 185 44 L 185 41 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 36 L 61 37.5 L 60 40 L 56 41.5 L 57 43.5 L 55 44.5 Q 54.3 38.3 57.5 36 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 38 L 251 46.5 L 247 48 L 247 44.5 L 250.5 38 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 41 L 170 43.5 L 168.5 48 Q 165.8 46.8 168 45.5 L 168.5 41 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 42 Q 179 40.8 178 44.5 L 179 46.5 L 178 46.5 Q 178.7 43.9 176 45 L 176 42 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 44 L 52 45.5 L 53 47.5 L 48.5 48 Q 45.7 46.8 48 45.5 L 48 44 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 49 L 174 56.5 L 174 61.5 L 173 64 L 171 63.5 L 172 62.5 L 172 56 Q 169 54.8 170 58.5 L 169 58.5 L 168.5 49 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 51 L 51 53 Q 48.3 51.9 49 54.5 L 49 56.5 L 48.5 58 Q 46.3 57.3 47 53.5 L 50.5 51 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102 52 L 106 52.5 L 102.5 54 L 102 52 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 54 L 182 56.5 L 180 56.5 L 179 64 L 181 64.5 Q 179.5 67.5 178 64.5 L 178 56.5 Q 180.4 57.1 180.5 54 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 54 L 241 54 L 241 59 Q 238 60.3 239 56.5 L 239.5 54 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 55 L 101 55.5 L 98.5 60 L 95.5 61 L 94 58.5 L 95 58.5 Q 94.3 60.8 96.5 60 L 99 59 L 98.5 55 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109 56 Q 112.3 54.7 111 59.5 L 110 59.5 L 109 56 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103 62 L 109 62 L 109 64 L 103 64 L 103 62 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233 62 L 236 62.5 L 236 71.5 L 231 74.5 L 232 77 L 226.5 80 L 226 78 L 224 77.5 L 226.5 77 Q 227.8 79.3 229 76.5 L 228 73.5 L 231 71.5 L 231.5 73 L 233 62 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 63 L 43 64.5 Q 42.8 69.3 39.5 71 Q 37 70 38 65.5 L 40.5 63 Z M 41 66 L 40 69 L 41 69 L 41 66 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 67 L 95 73.5 L 90.5 79 Q 88.3 79.8 89 77.5 L 90 72 L 93 71.5 L 91 70.5 L 93.5 67 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 69 Q 177.8 70.7 177 76.5 L 176 76.5 L 175.5 72 L 173 73 L 174.5 69 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173 74 L 175 74.5 L 173 75.5 L 173 74 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 77 L 116 78.5 L 115 80.5 L 115.5 82 L 113 78.5 L 115 78.5 L 115.5 77 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 80 L 94 81.5 L 94 92 Q 89.5 90.5 91 95 Q 94 94 93 97 L 90 97 L 90 89.5 L 92.5 80 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 81 L 176.5 83 L 177.5 81 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 82 L 114 84 L 116 84.5 L 114.5 85 L 113.5 82 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 83 L 175.5 85 L 174.5 83 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 84 L 34 86.5 L 33 86.5 L 32.5 84 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 86 L 221 89.5 L 215.5 97 L 215 95.5 L 216 93.5 L 214 93.5 L 217.5 88 Q 220 88.7 219.5 86 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 90 L 86 93.5 L 85 93.5 L 84.5 90 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118 92 L 120 92.5 Q 117 93.8 118 98 L 120.5 97 L 121 98.5 L 120 101 L 116 98.5 L 118 92 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 94 L 86 96.5 L 84.5 97 L 82.5 94 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 94 L 213.5 96 L 212.5 94 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 96 L 26 96.5 L 26 104 L 24 104.5 L 26 105.5 L 25 107.5 L 25 109.5 L 26 111.5 L 20 112 L 20 99.5 L 21 97 L 24.5 96 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 102 L 209 103.5 L 204 106 Q 206 112 200 110 L 199 107.5 L 207 103.5 L 206.5 102 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 103 L 129 104.5 L 127.5 104 L 126.5 103 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 104 L 78.5 106 L 77.5 104 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123 104 L 125 104 Q 123.9 106.7 126.5 106 L 127.5 108 Q 123.5 108.5 123 105.5 L 123 104 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 106 L 131 109.5 L 130 109.5 L 130.5 106 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 108 L 80 108.5 L 77.5 109 L 77.5 108 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 110 Q 67.5 111.5 64.5 113 Q 59.8 113.8 58 111.5 L 62.5 111 L 64.5 112 L 64.5 110 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 110 L 145.5 110 L 147 110.5 L 144.5 112 L 142 111.5 L 143.5 110 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 111 L 44.5 112 L 46 111.5 Q 44.8 114 41 113 L 41.5 111 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,252,249)",
    stroke: "rgb(254,252,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 112 L 76 112.5 L 72.5 113 L 72.5 112 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 20 L 234.5 20 L 235.5 21 L 239 20.5 L 216 66.5 L 210 82 Q 213 83.3 212 79.5 L 213 79.5 L 211 86.5 L 212 86.5 L 213.5 84 Q 215.8 84.8 215 82.5 L 219.5 77 L 219 78.5 L 205.5 97 Q 203.3 96.3 204 98.5 L 200.5 102 Q 199.3 99.8 198 102.5 L 197.5 104 L 196 103.5 L 195.5 105 L 193.5 104 L 193.5 106 L 190.5 105 L 190.5 106 L 192 106.5 L 187.5 107 L 184.5 106 L 182.5 106 Q 177 104.5 175.5 107 Q 174.3 104.8 169.5 106 L 166.5 107 L 160.5 106 L 158.5 107 L 149.5 105 L 149.5 106 L 151 106.5 L 139.5 107 L 136 106 L 135.5 104 L 133.5 104 L 129 100.5 Q 122.1 92.9 120 80.5 L 121 80.5 L 122 84 L 124 83.5 L 123.5 82 Q 125.8 82.8 125 80.5 L 126 80.5 L 127.5 83 L 128 79.5 L 121 56.5 L 114 41 L 111 39.5 L 112 36.5 L 109.5 38 L 107 38 Q 108.1 40.7 105.5 40 L 98.5 48 L 100 45.5 L 102 42.5 L 100 41.5 L 102.5 40 L 104 40.5 L 103 38.5 L 106 33.5 L 104.5 34 L 103 34.5 L 103.5 36 L 101.5 35 Q 88.3 45.4 81 60 Q 83.7 58.9 83 61.5 L 84 61.5 L 85.5 59 L 87 59.5 L 86 61.5 L 89 59.5 L 90.5 57 L 90 58.5 Q 91.1 61.8 88.5 61 L 85 68.5 L 86 68.5 L 88.5 63 L 89 64.5 L 81 90.5 L 71.5 103 L 61.5 108 L 54.5 109 L 53.5 108 L 40.5 108 L 40.5 109 L 42 109.5 L 40.5 110 L 33 108.5 L 43 92.5 L 46 81 L 48 80.5 L 47 77.5 L 56 56.5 L 67 41.5 L 68 38 L 70.5 39 L 71 35.5 L 70.5 34 L 72.5 35 L 76.5 30 L 72.5 33 L 75.5 29 L 77.5 30 L 81 27.5 Q 80.3 25.3 82.5 26 L 86.5 23 L 93.5 22 L 104 26 L 106 30 L 108.5 30 L 112.5 27 L 112.5 29 L 115 27.5 L 114.5 26 L 119.5 24 L 121 24.5 Q 120.1 21.5 124.5 23 L 125.5 22 L 133.5 22 L 144 28 L 151 40.5 L 160.5 71 L 161 66.5 L 160 64.5 L 162 63.5 L 161 65.5 L 163.5 64 L 166 63.5 L 165 60.5 L 166 60.5 L 170 79.5 L 174.5 92 L 177.5 88 L 180 86.5 L 192 70.5 L 202 35.5 L 201 33 L 197.5 32 L 200.5 37 Q 198.3 36.3 199 38.5 L 197 39.5 L 199 35 Q 196.3 36.1 197 33.5 L 196 32.5 L 202.5 26 L 213.5 21 Q 219.8 22.8 221.5 20 Z M 153 52 L 150 54 L 153 54 L 153 52 Z M 85 69 L 83 72 L 84 74 L 85 74 L 85 69 Z M 84 75 L 82 78 L 84 77 L 84 75 Z M 125 86 L 124 89 L 125 89 L 125 86 Z M 194 101 L 190 103 L 194 103 L 194 101 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 26 L 78.5 28 L 79.5 26 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 39 L 111 41.5 L 109 40.5 L 109.5 39 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 109 L 50 109.5 L 47.5 110 L 47.5 109 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 126 L 64 126.5 L 56.5 127 L 56.5 126 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 126 L 130 126.5 L 117.5 127 L 117.5 126 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 126 L 169 126.5 L 165.5 127 L 165.5 126 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 126 L 195 126.5 L 192.5 127 L 192.5 126 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 126 L 216 126.5 L 208.5 127 L 208.5 126 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,135,200)",
    stroke: "rgb(30,135,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 126 L 248 126.5 L 232.5 127 L 232.5 126 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 16 Q 97.3 14.7 96 18 Q 92.2 18.8 92.5 16 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197 16 Q 202.4 14.5 204 17.5 L 197 18 L 197 16 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 18 L 230.5 19 Q 231.8 16.8 236.5 18 L 239 19.5 L 214.5 20 L 201.5 25 L 197 29.5 L 189 44.5 L 180 76.5 L 178.5 78 L 178 76.5 L 180 72.5 Q 177.5 71 181 69.5 Q 180.2 64.2 183 62.5 L 183 54.5 L 186 50.5 L 187 43.5 L 189 39 Q 192 40.3 191 36.5 L 198.5 25 L 201 25 Q 199.9 22.3 202.5 23 L 204.5 21 L 214.5 18 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 18 L 253 19.5 L 245.5 21 L 240 19.5 L 246.5 18 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 19 L 95.5 21 L 96.5 20 L 118.5 20 L 123.5 21 L 133.5 19 L 135.5 19 L 139.5 20 L 141.5 20 L 146.5 20 L 153.5 26 Q 155.3 23.3 157 27.5 L 158 33.5 L 161 39 L 164 40.5 L 166 47.5 L 166 49.5 L 170 64.5 Q 167.5 66 171 67.5 Q 173.5 71 172 78.5 Q 175.5 80.2 174 86 Q 177 84.8 176 88.5 L 174 89.5 L 163 45.5 Q 158.8 31.8 148.5 24 L 143.5 22 L 86.5 22 Q 73.1 27.1 65 37.5 L 58.5 46 L 58 44.5 L 61.5 38 L 64.5 36 L 67 35 L 68 30 L 77.5 24 L 83 23 L 84.5 19 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 20 Q 196.1 18.3 195 22.5 L 192 24 L 192 20 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 21 L 254 22.5 L 254 25 L 252 25.5 L 252 29.5 Q 254.3 30.8 251.5 32 L 247.5 34 L 247 32.5 L 251 24.5 L 254.5 21 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56 32 Q 60.1 30.7 59 34 Q 54.9 35.3 56 32 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 35 L 248 37.5 L 243.5 47 L 242 46.5 L 240 49.5 Q 236.3 52.3 236 58.5 L 232 62.5 L 229 70.5 L 222 78.5 L 222 81.5 L 222.5 83 L 220 82 L 210.5 95 Q 208.3 94.3 209 96.5 L 205.5 101 L 194 109.5 L 194.5 111 L 191.5 108 L 190.5 109 L 188 108.5 L 197.5 105 L 210 93.5 L 216 84 Q 219 85.3 218 81.5 L 231 62.5 L 246.5 35 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 41 L 109 42.5 L 113 61.5 L 115 65.5 L 115 69.5 L 117 72.5 L 120 85.5 Q 124 98.5 133.5 106 Q 139.4 109 149 108.5 L 139 109.5 L 139.5 111 L 137.5 112 L 137.5 110 L 131 106.5 L 126.5 100 Q 124.3 104.3 122 99.5 L 123 95.5 L 118 88.5 L 117 83.5 L 118 81.5 L 114 73.5 Q 115.5 68 113 66.5 Q 115.5 65 112 63.5 L 111 53 L 108 51.5 L 107 48.5 L 108 44.5 Q 106 41 104 45.5 L 102 50.5 L 98.5 54 L 94 57.5 L 93 59.5 Q 95.5 61 92 62.5 L 88 79.5 Q 91.2 80.8 90 86.5 L 89 87.5 L 89 95 Q 85.5 96.1 87 88.5 L 88 83.5 L 86.5 80 L 85 83.5 L 85 85.5 Q 83 96 76.5 102 L 74 103.5 L 73 105.5 L 76 106 L 74.5 109 L 72 107.5 L 71.5 105 L 71 107 L 57.5 111 L 45.5 111 L 45.5 110 L 62.5 109 Q 72.5 105.5 78 97.5 L 83 88.5 L 91 59.5 L 106.5 41 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 44 L 181 46.5 L 180 46.5 L 180.5 44 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55 47 L 58 47.5 L 46 65.5 L 37 85.5 Q 36.1 94.6 32 100.5 L 32 104.5 L 29.5 108 L 29 105.5 L 28 97 L 32 96 L 38 80.5 L 38 78.5 L 40.5 73 Q 43.1 73.8 42 70.5 L 45.5 63 L 48 61.5 L 55 47 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102 57 L 107 57 L 107 58.5 Q 105.8 61 102 60 L 102 57 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 57 L 176 60.5 L 175 60.5 L 175.5 57 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 61 Q 241.5 60.2 240 64 L 237 62.5 L 238.5 61 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 108 L 169 108.5 L 167 109 Q 168.3 112.3 163.5 111 L 163.5 109 Q 159.5 109.8 160.5 108 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 108 L 183 108.5 L 176.5 110 L 173.5 109 L 173.5 108 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 110 L 42 110.5 Q 40.3 112.8 35.5 112 L 34.5 110 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67 110 L 70 110.5 L 67.5 112 L 67 110 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 110 Q 81.1 109.3 80 112 L 77 111.5 L 78.5 110 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,253,254)",
    stroke: "rgb(241,253,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 110 Q 131 109 130 112 Q 127 113 128 110 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 20 L 221 20.5 L 216.5 21 L 216.5 20 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 22 L 91 22.5 L 88.5 23 L 88.5 22 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 22 L 98 22.5 L 94.5 23 L 94.5 22 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 22 L 125 22.5 L 106 30 L 106 28 L 104 28 Q 105.1 25.3 102.5 26 L 99 23.5 L 100.5 22 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 22 L 138 23.5 L 136.5 24 L 134.5 22 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 23 L 86 23.5 L 81 26 L 79.5 29 L 71 35 Q 72 39.7 68.5 41 L 67 40.5 L 68 42.5 Q 66 40.8 64 44.5 L 53 62.5 L 47 79.5 L 47.5 81 Q 44.5 80.1 46 84.5 L 45 84.5 L 42 77.5 Q 52.6 48.6 73.5 30 L 75.5 30 L 77 29.5 Q 74.8 28.3 77.5 27 Q 78.8 29.3 80 26.5 Q 79.3 24.3 81.5 25 L 84.5 23 Z M 68 38 L 68 40 L 70 39 L 68 38 Z M 48 73 L 46 75 L 47 77 L 48 75 L 48 73 Z M 45 74 L 44 77 L 45 77 L 45 74 Z M 46 78 L 44 81 L 46 80 L 46 78 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 23 L 140.5 25 L 143.5 23 L 151 27.5 Q 150.3 29.8 152.5 29 L 161 42.5 L 166 59.5 L 165 62.5 L 166 62.5 L 166.5 61 L 167 62.5 L 161 66.5 L 160.5 71 L 151 40.5 L 144 28 L 139 24.5 L 140.5 23 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 24 L 203.5 26 L 199 29.5 L 199.5 31 Q 198.3 28.7 197 31.5 L 200.5 33 L 202 32.5 L 201 34.5 L 202 37.5 L 190.5 73 L 189.5 71 L 188 71.5 Q 189.3 67.8 185.5 69 L 183 70 L 192 38 L 194 37.5 L 194 35.5 L 195.5 33 L 197 32.5 L 196 31.5 L 202.5 25 L 204.5 24 Z M 198 33 Q 196 36 199 35 L 198 33 Z M 200 35 Q 198 38 201 37 L 200 35 Z M 192 65 L 190 67 L 192 67 L 192 65 Z M 191 68 L 190 71 L 191 71 L 191 68 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 27 L 236 28.5 L 232 36.5 L 236 37 L 230 57.5 L 231 57.5 Q 229.8 53.8 233.5 55 L 232 57.5 Q 227.3 69.8 219.5 79 Q 218.3 76.8 217 79.5 L 217.5 81 L 219 80.5 L 215 82.5 L 215.5 84 L 217 83.5 Q 215.8 86.3 214.5 84 L 212 85.5 L 210.5 88 L 209 87.5 L 211 87 L 213 79.5 L 212 79.5 L 212 82 Q 209.3 80.9 210 83.5 L 209 83.5 L 225 48 L 227 47.5 L 227 45.5 L 230.5 38 L 232 38.5 L 231 36.5 L 236.5 27 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 28 L 238 29.5 L 237 36 Q 234 37.3 235 33.5 L 238.5 28 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 33 L 107 35.5 L 105 35.5 L 106 37.5 L 103 38.5 L 104.5 41 L 106 40.5 L 100 44.5 L 100.5 46 L 102 45.5 L 94 56 Q 91.3 54.9 92 57.5 L 90.5 60 L 89.5 58 L 88 60.5 L 90 61 L 89.5 64 L 88 63.5 L 89 66.5 L 88 66.5 L 87.5 65 Q 84.5 68 84.5 74 L 83 71.5 L 87 62.5 L 86 60.5 L 86.5 59 L 84 60.5 L 83.5 62 L 83 60 Q 80.3 58.9 81 61.5 L 82 63.5 L 81 63.5 L 80.5 62 L 79 62.5 Q 87.9 46.4 101.5 35 L 105.5 33 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 36 L 113 39.5 L 112.5 41 Q 114.8 40.3 114 42.5 L 116 44.5 L 122.5 62 L 123.5 60 L 124 61.5 L 123 65.5 L 127 75.5 L 128 82.5 L 126 81.5 L 125.5 80 L 125 82 L 123 82.5 L 123.5 84 Q 121.3 84.8 122 82.5 L 121 82.5 L 120.5 85 L 116 71.5 L 116 67.5 L 114 63.5 L 114 59.5 L 109 41.5 L 110 39.5 L 107 38.5 L 111.5 36 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 52 L 60.5 54 L 61.5 52 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 52 L 151.5 53 L 153 52.5 Q 153.8 55.1 150.5 54 L 149.5 52 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 55 L 126 59.5 L 125 59.5 L 123.5 55 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 65 L 168 67.5 L 167 67.5 L 167.5 65 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 69 L 169 71.5 L 168 71.5 L 168.5 69 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 71 L 87 73.5 L 86 73.5 L 86.5 71 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 71 L 185 72.5 L 183.5 75 L 182.5 71 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 71 L 188.5 74 L 190 74.5 L 186 77.5 L 188 74.5 Q 185 73.5 186.5 71 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 75 L 84 76.5 L 82 77.5 L 83.5 75 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 80 L 180.5 85 L 184.5 80 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 82 Q 43.8 80.9 43 83.5 L 43.5 85 L 40.5 83 L 40.5 82 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 85 L 42 87.5 L 41 87.5 L 40.5 85 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 86 L 125 88.5 L 124 88.5 L 124.5 86 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 86 L 178.5 88 L 179.5 86 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 86 L 212.5 89 L 214.5 86 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 90 L 174.5 92 L 175.5 90 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 90 L 205.5 93 L 204.5 91 Q 206 93.5 207.5 90 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 91 L 43 92.5 L 40 94.5 L 42.5 91 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 91 L 79.5 93 L 80.5 91 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 91 L 209.5 93 L 210.5 91 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 95 L 126.5 97 L 125.5 95 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 96 L 76.5 98 L 77.5 96 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 97 L 204.5 99 L 205.5 97 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 98 L 128.5 100 L 127.5 98 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 100 L 37 101.5 L 33.5 108 L 34 106.5 L 37.5 100 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214 101 L 216 101.5 L 213.5 108 L 214 106.5 L 214 101 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 102 L 198.5 104 L 199.5 102 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 102 Q 218.3 104.8 222.5 104 L 222.5 102 L 225 107.5 L 223 106.5 Q 223.8 104.3 221.5 105 L 220.5 106 L 218 104.5 L 219 106.5 L 217 105.5 L 217.5 102 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 103 L 69.5 105 L 70.5 103 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 104 L 136 105.5 L 134.5 106 L 133.5 104 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 105 L 153 105.5 L 149.5 106 L 149.5 105 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 106 L 66 106.5 L 62.5 108 L 62.5 107 L 64.5 106 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 107 L 155 107.5 L 147.5 108 L 147.5 107 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 107 L 163 107.5 L 160.5 108 L 160.5 107 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 107 L 183 107.5 L 167.5 108 L 167.5 107 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 108 L 60 108.5 L 57.5 109 L 57.5 108 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 109 L 40 109.5 L 33.5 110 L 33.5 109 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 109 L 47 109.5 L 42.5 110 L 42.5 109 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 109 L 53 109.5 L 50.5 110 L 50.5 109 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 126 L 134 126.5 L 130.5 127 L 130.5 126 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 126 L 164 127.5 L 163.5 166 L 163 127.5 L 164.5 126 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 126 L 170.5 128 L 169.5 126 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 126 L 224 126.5 L 216.5 127 L 216.5 126 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 126 L 256 126.5 L 248.5 127 L 248.5 126 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 130 L 226 130.5 L 211.5 131 L 211.5 130 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 130 L 240.5 130 L 242 131.5 L 241.5 166 L 241 131 L 230.5 131 L 230.5 130 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 130 L 258 130.5 L 247 131 L 246.5 166 L 246 131.5 L 247.5 130 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 133 Q 171.3 134.3 169 135.5 L 168.5 166 L 168 135.5 L 168.5 133 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 134 L 92.5 136 L 93.5 134 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 134 L 134.5 136 L 133.5 134 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 135 L 176.5 137 L 175.5 135 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 136 L 83 138.5 L 82 138.5 L 82.5 136 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 143 L 87.5 147 L 84.5 143 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 143 L 224 143.5 L 212.5 144 L 212.5 143 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 149 L 138.5 151 L 139.5 149 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 157 L 98.5 159 L 99.5 157 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 157 L 190.5 159 L 189.5 157 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 161 L 227 161.5 L 211.5 162 L 211.5 161 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 166 L 98 166.5 L 90.5 167 L 90.5 166 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(127,191,221)",
    stroke: "rgb(127,191,221)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 166 L 154 166.5 L 151.5 167 L 151.5 166 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 27 L 115 27.5 L 112.5 29 L 113.5 27 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 28 L 118 28.5 L 116 29 L 115.5 31 L 115 29.5 L 116.5 28 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 97 L 192.5 99 L 193.5 97 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 100 L 198.5 103 L 200.5 100 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 100 L 216 100.5 L 214 101 L 213.5 107 L 212.5 100 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 101 L 192.5 103 L 190 102.5 L 193.5 101 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 101 L 220 103.5 L 218 102.5 L 218.5 101 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 101 Q 226.3 100.4 225 106.5 L 224 106.5 L 223.5 101 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 104 L 195 104.5 L 190.5 106 L 190.5 105 L 193.5 104 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 105 L 220.5 107 L 221.5 105 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 106 L 158 106.5 L 151.5 107 L 151.5 106 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 106 L 163 106.5 L 160.5 107 L 160.5 106 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 106 L 175 106.5 L 169.5 107 L 169.5 106 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 106 L 183 106.5 L 176.5 107 L 176.5 106 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 106 L 187 106.5 L 184.5 107 L 184.5 106 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 108 L 54 108.5 L 40.5 109 L 40.5 108 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 126 Q 103.2 124.9 108 127 L 108 134.5 L 106.5 135 Q 103.6 131.4 95.5 133 L 92 135.5 Q 90.5 139.9 93.5 139 L 96.5 142 L 104.5 145 L 109 149.5 L 110 157.5 L 105.5 164 Q 99 168 86.5 166 L 83 163.5 L 83.5 156 L 88.5 159 L 94.5 160 L 100 157.5 L 101 155.5 L 97.5 151 Q 88.3 149.3 84 142.5 L 83 134.5 L 86.5 129 L 93.5 126 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 126 L 226 130 L 211 130 L 211 141.5 Q 208.8 142.8 211.5 144 L 224.5 144 L 225 148 L 210 148.5 L 211 149.5 L 211 159.5 Q 208.8 160.8 211.5 162 L 226.5 162 L 227 164.5 L 225.5 166 L 206 166 L 206 127 L 223.5 127 L 224.5 126 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 126 L 258 129.5 L 246 130 L 246 165.5 L 242 166 L 242 131.5 L 240.5 130 L 230.5 130 L 230 127 L 255.5 127 L 256.5 126 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55 127 L 65.5 127 L 67 128.5 L 79 162.5 L 79 166 L 70.5 166 L 70 163.5 L 68 157 L 53.5 157 L 53 159.5 L 51 166 L 41 165.5 L 55 127 Z M 61 134 L 55 150 L 64 150 L 65 151 L 61 134 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116 127 L 136.5 127 L 144 132.5 L 145 141.5 L 140.5 149 Q 135.4 153.7 125 152 L 125 166 L 117.5 166 L 116 164.5 L 116 127 Z M 125 133 L 125 146 Q 131 147 135 144 L 136 141 L 135 136 Q 132 132 125 133 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164 127 Q 170.3 125.5 172 129.5 L 190.5 159 L 191 127 L 196 127.5 L 196 164.5 Q 195 167 190.5 166 L 168.5 133 L 168 166 L 164 165.5 L 164 127 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,32,49)",
    stroke: "rgb(14,32,49)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 160 L 155 161 L 156 163.5 Q 154.7 167 150 166 L 149 163.5 L 150 161 L 152.5 160 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85 16 L 88 17.5 Q 86.5 20.5 85 17.5 L 85 16 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 16 L 131.5 16 L 134.5 17 L 136 16.5 L 133.5 18 L 131.5 17 L 129 18.5 L 129.5 16 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 16 L 215.5 17 L 216.5 16 L 231.5 16 L 230.5 18 L 220.5 17 L 215.5 18 L 212.5 17 L 212.5 16 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 17 L 84 17.5 L 80.5 18 L 80.5 17 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 18 Q 93.3 17.3 94 19.5 L 92.5 19 Q 88.5 19.8 89.5 18 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 18 Q 119.3 17.3 120 19.5 L 113.5 20 L 113.5 19 L 115.5 18 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 20 L 201 21.5 L 196 25 L 193.5 29 L 191 28.5 L 193.5 25 L 200.5 20 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 23 L 75 23.5 L 72.5 24 L 72.5 23 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 23 L 159 25.5 L 157 24.5 L 157.5 23 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68 24 L 73 25.5 L 69 27 Q 70 30 67 29 L 68 24 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 32 Q 51.3 30.9 50 35 Q 46.7 36.1 48 32 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 40 L 57 41.5 L 56.5 43 L 56 41.5 L 57.5 40 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 41 L 187 47 L 185 47.5 L 185.5 49 Q 183.3 48.3 184 50.5 L 183 50.5 L 185 44.5 L 184.5 41 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105 45 L 107 45.5 L 107 52 Q 101.4 54.2 103 48.5 L 105 45 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 45 Q 179 43.8 178 47.5 L 176 46.5 L 176 45 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 48 Q 54.8 46.9 54 49.5 L 50 51 L 51.5 48 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 48 L 168 50.5 L 167 50.5 L 167.5 48 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 53 L 50 54.5 L 48 55.5 L 49.5 53 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 54 Q 241.3 55.2 239 56.5 L 238.5 59 L 238.5 54 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 55 L 99 59 L 94.5 61 L 96 58.5 L 95 57.5 L 97.5 55 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170 56 L 172 56.5 L 172 63 L 170 62.5 L 170 56 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 56 L 182 57.5 L 182 64 Q 177.1 65.8 179 59.5 L 180.5 56 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 64 L 43 66.5 L 41 66.5 L 40.5 69 L 40 66.5 L 41.5 64 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 70 L 232 72.5 L 231 72.5 L 231.5 70 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227 75 Q 229.7 73.9 229 76.5 L 227 77.5 L 227 75 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 79 Q 178.1 78.2 177 81.5 L 175.5 84 L 174 80.5 L 175.5 79 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 81 L 116 84 Q 112.5 85.1 114.5 81 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 89 L 86 91.5 L 85 93.5 L 85.5 95 Q 81.3 96.1 83 92 Q 86.1 93.1 85.5 89 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91 92 Q 94.3 90.9 93 95 Q 89.7 96.1 91 92 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 93 Q 122.5 92.1 121 96.5 L 118 98 Q 117 94.2 119.5 93 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 93 L 216 94.5 L 214 95.5 L 215.5 93 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 104 L 80 104 L 80 108 Q 77.3 109.1 78 106.5 L 78.5 104 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125 104 L 130 105 Q 131.7 110.2 128 109 L 126.5 106 Q 123.9 106.7 125 104 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 109 L 77 111.5 L 72 112 L 73.5 109 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 110 L 149 110.5 L 146.5 112 L 147.5 110 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,250,243)",
    stroke: "rgb(253,250,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 111 L 45 111.5 L 42.5 112 L 42.5 111 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240 20 L 252 21.5 L 245 37.5 L 229.5 64 L 230 62.5 L 234 55.5 L 231 55 Q 231.8 58.8 228.5 60 L 230 57.5 L 236 37 L 232 37 L 232 38.5 L 231 38.5 L 240 20 Z M 237 31 L 235 34 Q 234 37 237 36 L 237 31 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 22 Q 151.6 21.9 156 31.5 L 161 41.5 L 160 41.5 L 152.5 29 L 150.5 30 L 151 28.5 L 149.5 26 L 147.5 25 L 145.5 26 L 145.5 25 L 147 24.5 L 144.5 24 L 143.5 27 L 138.5 24 L 137.5 22 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 25 L 197.5 30 L 201.5 25 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 27 L 74.5 30 L 76.5 27 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 32 L 65.5 38 L 70.5 32 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 32 L 194.5 34 L 195.5 32 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 39 L 109 41.5 L 107.5 41 L 102.5 45 L 107.5 39 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 41 L 60.5 44 L 62.5 41 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 43 L 164 50.5 L 163 50.5 L 161.5 43 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 45 L 58.5 47 L 59.5 45 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 47 L 97.5 51 L 100.5 47 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 48 L 55.5 51 L 57.5 48 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 52 L 54 53.5 L 52.5 56 L 53 54.5 L 54.5 52 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 52 L 94.5 55 L 96.5 52 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 56 L 93 57.5 L 91 58.5 L 92.5 56 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 59 L 50 60.5 L 48.5 63 L 49 61.5 L 50.5 59 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 59 L 114 61.5 L 113 61.5 L 113.5 59 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 60 L 185 63.5 L 183.5 66 L 183 64.5 L 184.5 60 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 64 L 49 66.5 L 47 66.5 L 44 73.5 L 45 76.5 L 44 76.5 L 43.5 74 L 42 77.5 L 43.5 81 L 45.5 78 L 46 79.5 Q 42.5 81 45 82.5 L 43 90.5 L 34 107 L 32 107.5 L 33 109.5 L 31 108.5 L 32 102 L 34 101.5 L 33 98.5 Q 38.4 79.4 47.5 64 Z M 41 82 L 41 83 L 44 85 L 43 84 Q 44 81 41 82 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 65 L 192 67 L 190 66.5 L 191.5 65 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 65 L 227.5 67 L 228.5 65 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 67 L 116 69.5 L 115 69.5 L 115.5 67 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 68 L 183 70 L 188 69 L 188.5 72 L 190.5 68 L 191 70.5 L 190 74 Q 187.3 72.9 188 75.5 L 174.5 91 L 176 88.5 L 182.5 68 Z M 183 72 L 184 75 L 185 73 L 183 72 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 73 L 48 74.5 L 46.5 77 L 46 74.5 L 47.5 73 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 73 L 222.5 75 L 223.5 73 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 75 L 171 77.5 L 170 77.5 L 170.5 75 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 78 L 219.5 80 L 220.5 78 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 79 L 172 81.5 L 171 81.5 L 171.5 79 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 86 L 83 88.5 L 81 89.5 L 82.5 86 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 89 L 211.5 91 L 212.5 89 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 92 L 80 93.5 L 78.5 96 L 79 94.5 L 80.5 92 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 93 L 206.5 97 L 209.5 93 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 96 L 126.5 98 L 125.5 96 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 97 L 75.5 100 L 77.5 97 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 99 L 133.5 106 L 127.5 99 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 99 L 201.5 102 L 203.5 99 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 101 L 70.5 105 L 73.5 101 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 107 L 147 107.5 L 139.5 108 L 139.5 107 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 107 L 160 107.5 L 155.5 108 L 155.5 107 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 107 L 167 107.5 L 163.5 108 L 163.5 107 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 107 L 191 107.5 L 183.5 108 L 183.5 107 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 107 L 219 107.5 L 216.5 108 L 216.5 107 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 108 L 63 108.5 L 60.5 109 L 60.5 108 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 109 L 56 109.5 L 53.5 110 L 53.5 109 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 125 L 101 125.5 L 96.5 126 L 96.5 125 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 127 L 191 137.5 L 190 137.5 L 190.5 127 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 127 L 206 165.5 L 205 165.5 L 205.5 127 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 131 L 109 134.5 L 107 135.5 L 108.5 131 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 133 L 130 133.5 L 125.5 135 L 126.5 133 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 136 L 126 144.5 L 125 144.5 L 125.5 136 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 146 L 107.5 148 L 106.5 146 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 152 L 132 152.5 L 126.5 153 L 126.5 152 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 154 L 126 163.5 L 125 163.5 L 125.5 154 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 155 L 82.5 157 L 83.5 155 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 157 L 66 157.5 L 55.5 158 L 55.5 157 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(200,233,243)",
    stroke: "rgb(200,233,243)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 158 L 83 162.5 L 82 162.5 L 82.5 158 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 16 Q 79.8 15.3 79 17.5 L 79.5 19 L 76 17.5 L 77.5 16 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107 16 L 110 16.5 L 107 18 L 107 16 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 16 L 138.5 18 L 137.5 16 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 21 L 160 24 Q 156.5 25.1 158.5 21 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 24 L 163 24.5 L 160.5 26 L 161.5 24 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 24 L 192 26.5 L 190.5 31 L 190.5 24 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 26 L 157.5 28 L 158.5 26 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 28 L 256 31.5 L 254 30.5 L 253.5 29 L 252 29.5 L 253.5 28 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 30 L 162.5 32 Q 159.7 32.7 161.5 30 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175 33 L 177 33.5 L 175.5 36 L 175 33 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 34 L 62 37.5 L 60 38.5 L 61 35.5 L 61.5 34 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 43 L 56 46.5 L 55 46.5 Q 55.8 43.9 52.5 45 L 53.5 43 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 43 L 171.5 45 L 169 44.5 L 170.5 43 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 46 L 171.5 48 L 172.5 46 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 50 L 181 53.5 L 179.5 56 L 179 54.5 L 180 51.5 L 179.5 50 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 53 L 109 55.5 L 107 54.5 L 107.5 53 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 54 L 96.5 56 L 97.5 54 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42 56 L 46 56 L 46 62.5 L 44.5 64 L 42 63.5 L 42 56 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 57 L 111 60.5 L 108.5 61 L 107 60.5 L 108.5 57 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 58 L 101 60 L 99 59.5 L 100.5 58 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 63 L 171 66.5 L 170 66.5 L 170.5 63 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 66 L 173 69.5 L 172 69.5 L 172.5 66 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 71 L 40.5 73 L 39.5 71 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 75 L 173.5 77 L 174.5 75 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225 75 L 227 75.5 L 225 76.5 L 225 75 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 80 L 37 81.5 L 35 82.5 L 36.5 80 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 97 L 84 97.5 L 80.5 98 L 80.5 97 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 98 L 121 99.5 L 120.5 101 L 120 99.5 L 121.5 98 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 98 Q 227.8 97.3 227 99.5 L 225.5 98 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 101 L 232 101.5 L 229.5 103 L 230.5 101 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 102 L 115 103.5 L 112 103.5 L 112 102 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 104 L 230.5 106 L 229.5 104 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68 108 L 70 108.5 L 68 109.5 L 68 108 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 108 L 75.5 110 L 76.5 108 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 108 L 137 110.5 L 135.5 110 L 133.5 108 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 109 L 140.5 111 L 141.5 109 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 109 L 179 111 L 182 111.5 L 178 112 L 178.5 109 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 120 L 99 122.5 Q 97.5 125.5 96 122.5 L 97.5 120 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 120 L 110.5 122 L 109 121.5 L 111.5 120 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 120 Q 121.1 119.2 120 122.5 L 119 122.5 L 118.5 120 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 120 Q 171.1 119.2 170 122.5 L 169 122.5 L 168.5 120 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 120 L 176 121.5 L 174.5 121 L 173.5 120 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 120 L 186 122.5 L 185 122.5 L 185.5 120 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 121 Q 67.3 122.2 65 123.5 L 64.5 126 L 64 123.5 L 64.5 121 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 121 L 72 123.5 L 71 123.5 L 71.5 121 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 121 L 131 121.5 L 128.5 123 L 128 121 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 121 L 167 122.5 L 165.5 122 L 164.5 121 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 122 L 106 123.5 L 104.5 123 L 103.5 122 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 122 Q 114.8 121.3 114 123.5 L 114.5 125 L 112.5 122 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 122 L 225.5 124 L 226.5 122 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 123 L 89 125 Q 91.7 123.9 91 126.5 L 88 124.5 L 88.5 123 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 123 L 260 125 L 258 124.5 L 259.5 123 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 124 Q 135.8 123.3 135 125.5 L 133.5 124 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 126 L 176 128.5 L 175 128.5 L 174.5 126 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 128 L 198 143.5 L 197 143.5 L 197.5 128 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 131 L 260 132.5 L 257.5 134 L 257.5 133 Q 260 133.7 259.5 131 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 132 L 112 132.5 Q 109.9 135.8 109.5 132 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 132 L 248.5 134 L 247 133.5 L 249.5 132 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 132 L 256 132.5 L 252.5 133 L 252.5 132 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 133 L 149 135.5 L 145.5 138 L 145.5 137 L 148 135.5 L 148.5 133 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 134 L 184 135.5 L 180.5 137 L 180 135 Q 175.6 136 176.5 134 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 134 L 229 135.5 L 228.5 137 L 228 135.5 L 229.5 134 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 135 L 72 137.5 L 71 137.5 L 71.5 135 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 135 L 97.5 138 Q 95.3 138.8 96 136.5 L 97.5 135 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 135 L 249 136.5 L 248.5 168 L 248 136.5 L 249.5 135 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 136 L 109 136.5 L 107 139.5 L 112 142.5 L 110.5 143 L 104 141 L 104 137 L 105.5 137 L 106.5 136 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 136 L 129 139.5 L 128 142.5 L 129.5 145 L 127 144 L 127.5 136 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 136 L 162 161.5 L 161 161.5 L 161.5 136 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 136 L 188 136.5 L 185.5 138 L 185 136 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 136 L 253 159.5 L 252 159.5 L 252.5 136 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 137 L 76 137.5 L 73.5 139 L 74.5 137 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 137 L 80 138.5 L 79.5 140 L 79 138.5 L 80.5 137 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 137 L 214.5 139 L 213.5 137 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 138 L 189 141.5 L 188 141.5 L 188.5 138 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 140 L 77 143 Q 72.9 144.3 74 141 L 76.5 140 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 140 L 223.5 142 L 216 141.5 L 224.5 140 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 140 L 228 142.5 L 227 142.5 L 226.5 140 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 141 L 58.5 143 L 59.5 141 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 142 L 148 142.5 L 148 144.5 L 148 153.5 L 146.5 154 Q 144.8 156.8 138.5 155 L 138.5 154 L 141 153.5 L 139 152.5 Q 140.8 149.3 142.5 153 L 145.5 154 L 146.5 152 L 144 152 L 144 144 L 146 143.5 L 145.5 142 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 142 L 172.5 145 L 177 146.5 L 170.5 149 L 170.5 148 L 173 146.5 Q 168.8 144.2 173.5 142 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 142 L 188 143.5 L 185 144 L 185.5 142 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 144 L 204 151.5 L 203 151.5 L 203.5 144 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 146 L 43 146.5 L 40.5 148 L 41.5 146 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 146 L 59 148.5 L 57 147.5 L 57.5 146 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 149 L 80 151.5 L 80 153.5 L 78.5 157 L 77 154.5 L 79 154.5 L 76.5 149 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 150 L 112 152.5 L 110 151.5 L 111.5 150 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 150 Q 173.3 151.3 171 152.5 L 170.5 160 L 170.5 150 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 150 L 215 151.5 L 213.5 151 L 212.5 150 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 151 L 89.5 153 L 87.5 154 L 88 152.5 L 88.5 151 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 152 L 95.5 155 L 93.5 152 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 153 L 92.5 155 L 91.5 153 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127 153 L 130 153.5 L 127.5 155 L 127 153 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 153 L 189.5 156 Q 186.5 154.5 189.5 153 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 155 L 136 155.5 L 133.5 156 L 133.5 155 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148 155 L 152 155.5 L 152 157.5 Q 152.8 160.1 149.5 159 L 148 155 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 157 Q 145.7 155.9 144 160 L 140 158.5 L 141.5 157 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 158 L 80.5 160 L 79.5 158 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 158 L 179.5 160 L 178.5 158 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 159 L 64 159.5 L 56.5 160 L 56.5 159 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 160 Q 159.8 159.3 159 161.5 L 157.5 160 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 162 L 172 164.5 L 169.5 166 L 170 164.5 L 171.5 162 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 162 L 198.5 164 L 202 166.5 L 199.5 165 L 197 163.5 L 198.5 162 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 163 L 55 166.5 L 54 166.5 L 54.5 163 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 163 L 163 164.5 L 161.5 165 L 160.5 163 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65 164 L 68 164.5 L 64.5 167 L 65 165.5 L 65 164 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 165 L 84 165.5 L 80.5 167 L 81.5 165 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 165 L 109.5 167 L 110.5 165 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 165 L 231.5 169 L 224 168.5 L 230 167.5 L 228.5 165 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 167 L 81.5 168 L 83.5 167 L 88 168.5 L 72.5 169 L 72.5 168 Q 77.3 169.3 78.5 167 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 167 L 104 168.5 L 96.5 169 L 96.5 168 L 99.5 167 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 167 L 159.5 169 L 152 168.5 L 158.5 167 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 172 L 88 172.5 L 72.5 173 L 72.5 172 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 172 L 160 172.5 L 152.5 173 L 152.5 172 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 172 L 232 172.5 L 224.5 173 L 224.5 172 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 16 L 145 17.5 L 142 19 L 142.5 16 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 16 L 245.5 16 L 248 16.5 L 243 18 L 243.5 16 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 18 L 101 19.5 L 99.5 20 L 98.5 18 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 21 Q 154.8 20.3 154 22.5 L 151 22.5 L 152.5 21 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 29 L 159 31.5 L 158 31.5 L 158.5 29 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 42 L 49.5 44 Q 46.7 44.7 48.5 42 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 48 L 49.5 50 L 48.5 48 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 54 L 104 55.5 L 102.5 56 L 101.5 54 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 64 L 175 67.5 L 174 67.5 L 174.5 64 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 65 L 113 65.5 L 111 66.5 L 111 65 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 80 L 33 83.5 L 32 83.5 L 32.5 80 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117 91 L 119 91.5 L 117.5 94 L 117 91 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 102 L 120.5 104 L 121.5 102 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125 108 Q 128.3 106.7 127 111.5 L 126 111.5 L 125 108 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 109 L 161.5 112 Q 159.3 112.8 160 110.5 L 159.5 109 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 109 L 189 109.5 L 186.5 110 L 186.5 109 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172 110 Q 175 109 174 112 Q 171 113 172 110 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,252)",
    stroke: "rgb(252,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 111 L 144 113 L 142 112.5 L 143.5 111 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 19 Q 257 21 252.5 23 L 253.5 19 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 22 L 80 24 L 77 23.5 L 79.5 22 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 23 L 152.5 25 L 151.5 23 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 23 L 195 25 L 193 25.5 L 193.5 27 Q 190 25 194.5 23 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 29 L 70 29.5 L 68 30 L 67.5 32 L 67 30.5 L 68.5 29 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 34 L 192 36 L 189.5 37 L 191.5 34 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 44 L 56.5 46 L 57.5 44 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 48 L 166.5 50 L 165.5 48 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 51 L 168 53.5 L 167 53.5 L 167.5 51 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 51 Q 186.5 52.5 183.5 54 L 183.5 51 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 64 L 92 67.5 L 91 67.5 L 91.5 64 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 65 L 44 67.5 L 42 68.5 L 43.5 65 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 68 L 232 69.5 L 230 70.5 L 231.5 68 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 76 L 113 78.5 L 112 78.5 L 112.5 76 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 78 L 179 79.5 L 177 80.5 L 178.5 78 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 79 L 117 82.5 L 116 82.5 L 116.5 79 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 87 L 86.5 89 L 85.5 87 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 89 L 84 90.5 L 83.5 92 L 83 90.5 L 84.5 89 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 97 L 217.5 99 L 218.5 97 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 99 L 212.5 104 Q 210.2 99.8 208 101.5 L 208.5 99 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 100 L 225.5 102 L 226.5 100 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 101 L 124.5 103 L 123.5 101 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 102 L 128.5 104 L 127.5 102 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 108 L 31 110.5 L 29 109.5 L 29.5 108 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 108 L 194.5 110 L 195.5 108 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 109 L 176 109.5 L 173.5 110 L 173.5 109 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 110 L 35 111.5 L 33.5 111 L 32.5 110 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 110 L 136.5 112 L 137.5 110 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 110 L 198 110.5 L 195.5 112 L 196.5 110 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 110 L 216 111.5 L 213.5 112 L 212.5 110 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 120 L 65.5 122 L 66.5 120 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 122 L 91 123.5 L 89.5 124 L 88.5 122 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 122 L 192 124 L 189.5 125 L 191.5 122 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 122 L 205 122.5 L 202.5 124 L 203.5 122 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 124 L 70 126 L 72 126.5 L 70.5 127 L 69.5 124 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 125 L 51 126.5 L 52 128.5 L 50 127.5 L 51.5 125 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 125 L 114 125.5 L 109.5 127 L 109.5 126 L 111.5 125 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 125 L 228 126.5 L 227.5 128 L 227 126.5 L 228.5 125 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 126 L 175 127.5 L 174.5 129 L 174 127.5 L 175.5 126 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 128 Q 144.8 126.9 144 129.5 L 142.5 129 L 141.5 128 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 129 L 83 131.5 L 82 131.5 L 81.5 129 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 132 L 230.5 134 L 229.5 132 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 136 L 150 138.5 L 148 137.5 L 148.5 136 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 137 Q 185 139 181.5 141 L 180.5 137 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 138 L 148 141.5 L 147 141.5 L 146.5 138 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 141 L 108 143.5 L 104 144 L 103.5 141 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 141 L 130.5 143 Q 127.7 143.7 129.5 141 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 142 L 60 144.5 L 59 144.5 L 59.5 142 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 142 L 83 142.5 L 80.5 144 L 81.5 142 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 142 L 133.5 144 L 132.5 142 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 143 L 75 144.5 L 74.5 146 L 74 144 L 72.5 143 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 144 L 44.5 146 L 43.5 144 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 146 L 85.5 148 L 84.5 146 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 146 L 225.5 148 L 226.5 146 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 147 L 46 147.5 L 44 148 L 43.5 151 L 43 148.5 L 44.5 147 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 148 L 178.5 151 L 176.5 148 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 148 L 187.5 150 Q 184.7 150.7 186.5 148 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 153 L 97 154.5 L 98 156.5 L 96 155.5 L 97.5 153 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 153 L 110.5 155 L 111.5 153 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 154 L 43.5 156 L 42.5 154 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 155 L 94 155.5 L 92 156.5 L 95 157.5 L 92.5 158 Q 89.5 156.5 92.5 155 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 160 L 147.5 162 L 148.5 160 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 162 L 110 162.5 L 106 165.5 L 106.5 167 L 105 165.5 L 108.5 162 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 162 Q 113.8 161.3 113 163.5 L 113.5 165 L 111.5 162 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183 162 L 185 162.5 L 184 165.5 L 185.5 168 Q 182 166.7 183 162 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 165 L 80.5 168 Q 77.5 166.5 80.5 165 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 165 L 145.5 167 L 146.5 165 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 165 L 204 166.5 L 202.5 167 L 201.5 165 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 166 L 115 167.5 L 113.5 167 Q 110.5 167.5 111.5 166 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,248,247)",
    stroke: "rgb(246,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 166 L 156.5 166 L 158 166.5 L 155.5 168 L 154.5 166 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 20 L 254 20.5 L 251.5 24 L 251 22.5 L 251.5 21 Q 246.5 22 247.5 20 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 24 L 75.5 26 L 76.5 24 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 27 L 193 28.5 Q 192.3 30.8 194.5 30 L 193.5 32 L 192 28.5 L 193.5 27 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 91 L 215 92.5 L 213.5 95 L 213 93.5 L 214.5 91 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 95 L 211 97.5 L 208 97.5 L 209.5 95 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 96 Q 215.5 97.5 212.5 99 L 212.5 96 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 99 L 206.5 101 L 207.5 99 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 102 L 74.5 104 L 75.5 102 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 102 L 208 102.5 Q 205.9 105.8 205.5 102 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 106 L 214.5 108 L 215.5 106 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 107 L 32 109.5 L 30 110 L 30.5 107 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 109 L 219 109.5 L 216.5 111 L 217.5 109 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 110 L 222.5 112 L 221.5 110 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 127 L 69 128.5 L 67 129.5 L 68.5 127 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 127 L 175 130.5 L 173 129.5 L 173.5 127 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227 129 L 229 129.5 L 226 131.5 L 227 129 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 134 L 80.5 137 L 82.5 134 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 134 L 110.5 136 L 109 135.5 L 111.5 134 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 136 L 180 136.5 L 177.5 138 L 178.5 136 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 138 L 191 141.5 L 190 141.5 L 190.5 138 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 140 L 132.5 142 L 133.5 140 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 141 L 180.5 143 L 181.5 141 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 142 L 182.5 144 L 183.5 142 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 144 L 109 145.5 L 109.5 144 L 110 145.5 L 108.5 147 Q 106.7 143.9 105 145.5 L 106.5 144 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 144 L 191 144.5 L 190.5 147 Q 189 143.5 187.5 146 L 186 145.5 L 188.5 144 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 145 L 86.5 147 L 85.5 145 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 146 L 109.5 149 L 111.5 146 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 146 L 186 148.5 L 185 148.5 L 184.5 146 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 149 L 91 150.5 L 89.5 151 L 88.5 149 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 149 Q 145.5 150.5 142.5 152 Q 139.5 150.5 142.5 149 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 151 L 177.5 153 L 176.5 151 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 153 L 86.5 155 L 85.5 153 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 153 L 99.5 155 L 98.5 153 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 157 L 54.5 160 Q 51.5 158.5 54.5 157 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 157 L 181.5 159 L 182.5 157 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 161 L 81 162.5 L 79 163.5 L 80.5 161 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 161 L 112 164.5 L 110 163.5 L 109.5 161 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 162 L 67.5 164 L 66.5 162 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 163 L 184.5 165 L 185.5 163 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 163 L 228.5 165 L 229.5 163 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51 164 L 54 165.5 L 52.5 168 L 53 166.5 L 52.5 165 L 49.5 167 L 49.5 166 Q 52.1 166.7 51 164 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 164 L 185.5 167 L 187.5 164 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 165 L 108.5 168 L 106 167.5 L 106.5 165 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 166 L 46 166.5 L 42.5 168 L 40 167.5 L 41.5 166 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 166 L 70.5 166 L 75 166.5 L 69.5 168 L 68.5 166 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 166 L 125 166.5 L 116.5 167 L 115.5 168 L 116.5 166 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 166 L 149.5 168 L 148.5 166 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 166 L 169 166.5 L 164.5 167 L 164.5 166 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 166 L 214 166.5 L 206.5 167 L 206.5 166 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 166 L 224 166.5 L 216.5 167 L 216.5 166 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 166 L 228 167.5 L 226.5 167 L 225.5 166 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,241,241)",
    stroke: "rgb(240,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 166 L 246 166.5 L 241.5 167 L 241.5 166 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 8 L 32 8 L 32 16 L 8 16 L 8 8 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40 8 L 64 8 L 64 16 L 40 16 L 40 8 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 8 L 175.5 8 L 176 8.5 L 176 16 L 161.5 16 L 161 17.5 L 158.5 19 L 158.5 18 Q 161.1 18.7 160 16 L 156 16.5 L 157 17.5 L 153.5 21 L 152 21.5 Q 157.2 23.7 153.5 26 L 152 22 Q 148.9 22.8 149.5 20 L 144.5 20 L 144.5 19 L 152 18 L 152 15 L 159.5 15 L 160 13 L 152.5 13 L 152 11 L 159.5 11 L 160 9 L 152.5 9 L 152.5 8 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 8 L 216 8.5 L 208.5 9 L 208.5 8 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 8 L 232 8.5 L 224.5 9 L 224.5 8 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264 8 L 280 8 L 280 16 L 264 16 L 264 8 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208 12 L 215.5 12 L 216 14 L 208.5 14 L 208 12 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 12 L 231.5 12 L 232 14 L 224.5 14 L 224 12 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 15 L 96 15.5 L 92.5 16 L 92.5 15 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 15 Q 125.5 13.5 128 17.5 L 126.5 17 Q 121.8 15.7 120.5 18 L 117.5 16 L 117.5 18 L 115 16.5 L 117.5 15 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140 15 L 144 15.5 L 140 17 L 140 15 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 15 Q 149.8 14.3 149 16.5 Q 147.8 19.2 146.5 17 L 145 16.5 L 147.5 15 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 15 Q 204.3 14.3 207 16.5 L 203.5 17 L 198.5 16 L 198.5 15 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 15 Q 238.6 13.8 238 16.5 L 236 17.5 L 236.5 16 L 233.5 18 L 233.5 16 L 232.5 15 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 15 L 255.5 15 L 257 16.5 L 253 17 Q 254.3 20.3 249.5 19 L 249.5 18 L 251 17.5 L 248.5 17 L 245.5 19 L 246.5 17 L 248 16.5 L 245.5 16 L 243.5 16 Q 239.5 16.8 240.5 15 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 16 L 76 18.5 Q 76.8 20.8 74.5 20 L 65 26.5 L 64.5 28 L 56 28 L 56.5 26 L 63.5 26 L 72 20.5 L 69 20 L 70.5 17 L 72.5 16 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 16 L 113 16.5 L 112 19 L 107 18.5 L 111 18 L 111 16 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 17 Q 100.8 16.3 100 18.5 L 95.5 21 L 96.5 19 L 99 18.5 L 98.5 17 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 18 L 67 18.5 L 64.5 19 L 64.5 18 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 18 L 85 18.5 L 84 21 L 80 20.5 L 83.5 18 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 18 L 133 18.5 L 129.5 20 L 129.5 19 L 131.5 18 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 18 L 139.5 20 L 137 19.5 L 138.5 18 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 18 L 200 18.5 L 196.5 19 L 196.5 18 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 18 Q 205.8 16.9 205 19.5 L 203.5 19 L 202.5 18 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 18 L 244 18.5 L 241.5 19 L 241.5 18 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 19 L 128 19.5 L 124.5 20 L 124.5 19 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 20 L 66 22 L 64 21.5 L 65.5 20 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 20 L 192 22.5 L 191 22.5 L 191.5 20 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 21 L 256 22.5 L 254 23.5 L 255.5 21 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 24 L 16 24 L 16 32 L 8 32 L 8 24 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 24 L 168 31 L 172 31.5 L 171 34.5 L 172 37 L 176 38 Q 174.5 34.2 177.5 35 Q 180 36.2 179 40 Q 176.3 38.9 177 41.5 L 175 46.5 L 179 48 L 178 41 L 181.5 43 L 182 39.5 L 181.5 38 Q 184.5 37.5 183 44.5 L 181.5 50 L 181 48 L 179 48 Q 180.1 50.7 177.5 50 L 174 52 L 173 47.5 L 173 45.5 Q 174.3 40.3 171.5 39 L 169 40 L 168.5 38 L 167 42.5 L 168 45.5 L 166.5 48 L 163 39.5 Q 166.2 37.2 165 30.5 L 163 27.5 L 167.5 24 Z M 181 44 L 180 47 L 181 47 L 181 44 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185 24 L 189 24 L 189 32.5 L 190 34.5 L 189 34.5 L 187.5 32 L 187 34.5 L 188 37.5 L 187 37.5 Q 187.7 34.9 185 36 L 186 38.5 L 184 37.5 L 185 35.5 L 184 32.5 L 185 31.5 L 185 24 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 24 L 280 24 L 280 32 L 272 32 L 272 24 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 25 L 74 26.5 L 72 27.5 L 73.5 25 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 25 L 257 26.5 Q 255.8 29.3 254.5 27 L 252.5 28 L 252.5 25 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52 31 L 55.5 32 L 58.5 31 L 58.5 32 L 55.5 33 L 54 32.5 L 55.5 35 L 57 34.5 L 55 41 Q 52.3 42.1 53 39.5 Q 50.3 38.8 51 34.5 L 52 31 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 31 L 65 31.5 L 60.5 32 L 60.5 31 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249 32 L 251 32.5 L 247 40.5 L 248 42.5 L 246 41.5 L 248 36.5 L 247 34 Q 250 35 249 32 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 33 L 159.5 35 L 158.5 33 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 34 L 254 36.5 L 253 38.5 L 254 42 Q 257 43.3 256 39.5 L 257 39.5 L 257 47.5 L 255.5 49 L 252 47.5 L 253 39.5 L 252 35.5 L 253.5 34 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 37 L 191 39 L 189 38.5 L 190.5 37 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 39 Q 50.8 38.3 50 40.5 L 51 43.5 L 48 42.5 L 47.5 44 L 47 40.5 L 48.5 39 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 40 L 16 40 L 16 48 L 8 48 L 8 40 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 40 L 280 40 L 280 48 L 272 48 L 272 40 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 42 L 58.5 44 L 57.5 42 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 45 L 243.5 48 Q 241.3 48.8 242 46.5 L 241.5 45 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 48 L 49.5 48 L 51 48.5 L 49 49 L 47.5 52 L 47.5 48 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170 48 L 172 48.5 L 170 49.5 L 170 48 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 50 L 102 51.5 Q 102.5 55.5 99.5 56 L 99 54.5 L 102.5 50 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 51 L 173 52.5 L 172.5 54 L 170.5 51 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239 52 L 241 52.5 L 239 53.5 L 239 52 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 53 L 107 54.5 L 103 55 L 103.5 53 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 53 L 179 55.5 L 176 56 Q 177.1 53.3 174.5 54 L 174.5 53 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 56 L 39.5 56 L 40 58 L 32.5 58 L 31.5 59 L 8.5 59 L 7.5 58 L 0 58 L 0 56 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101 56 L 108 56.5 L 101.5 58 L 101 56 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 56 L 287.5 56 L 288 58 L 280.5 58 L 279.5 59 L 256.5 59 L 255.5 58 L 248 58 L 248 56 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 58 L 177 65.5 L 176 67.5 Q 178.3 68.8 175.5 70 L 175 64.5 Q 177.5 63 174 61.5 L 174.5 59 L 175.5 61 L 176.5 58 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 59 L 48 61.5 L 47 61.5 L 47.5 59 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 59 L 241 63.5 L 241 65.5 L 241 72 L 248 72 L 248 80 L 228.5 80 L 228 78 L 232 76.5 L 231 74.5 L 232.5 74 L 234 77 L 236 77 L 236 72 L 238 72 L 238 65.5 L 237.5 64 Q 241.3 65.3 240 61.5 L 239.5 59 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8.5 61 L 31.5 61 L 32.5 62 L 40 62 L 38 65.5 L 38 69 Q 35 70 36 67 L 32 67 L 31.5 64 L 0.5 64 L 0 62 L 7.5 62 L 8.5 61 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 61 L 94 63 L 96.5 64 L 97 61 L 101 62.5 L 100 65 Q 96.3 63.5 97 66.5 L 96 69 Q 93 70 94 67 L 96 66.5 L 92 66 L 93.5 61 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 61 L 279.5 61 L 280.5 62 L 288 62 L 287.5 64 L 248 64 L 248.5 62 L 255.5 62 L 256.5 61 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 63 L 174 65.5 L 173 65.5 L 173.5 63 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 65 L 172 67.5 L 171 67.5 L 171.5 65 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 68 Q 182.1 67.3 181 70 L 178 69.5 L 179.5 68 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 68 L 230 69.5 L 228.5 72 L 229 70.5 L 230.5 68 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 69 L 43 69.5 L 40.5 71 L 41.5 69 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 72 L 34.5 72 L 35 72.5 L 35 79.5 L 36 81.5 L 35 81.5 L 34.5 80 L 33.5 85 L 32.5 80 L 31.5 85 L 31 80 L 8 80 L 8 72 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95 72 L 104 72 L 104 80 L 96 80 L 96 88 L 103.5 88 L 104 85 L 112 85 L 112.5 87 L 113.5 84 L 115.5 85 L 117 84.5 L 115 87.5 L 116.5 88 L 118 87.5 L 117 88.5 L 116 99.5 Q 117.2 102 121 101 L 121.5 99 L 123 103 L 125 103.5 L 123 104 Q 122.3 107.4 125 108.5 L 123.5 112 L 123 109 Q 117.6 107.5 116 110.5 L 116.5 112 Q 109.8 114.3 112 107.5 L 115 106.5 L 116 100.5 L 114.5 101 L 112 100.5 L 115 100 L 114 97.5 L 114.5 96 L 112 96 L 111.5 99 L 96 99 Q 97.5 95.3 94.5 96 L 93 96.5 Q 92.3 94.3 94.5 95 L 94 93.5 Q 92.8 85.3 95 80.5 L 93 80.5 L 93 75.5 L 95 72 Z M 104 88 L 104 96 L 111 96 L 112 93 L 112 88 L 104 88 Z M 116 92 L 115 95 L 116 95 L 116 92 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 72 L 280 72 L 280 80 L 256 80 L 256 72 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 73 L 113.5 75 Q 110.7 75.7 112.5 73 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 75 L 173 78.5 L 172 78.5 L 172.5 75 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 79 L 224 83.5 L 223 83.5 L 222.5 82 L 222 85 L 231.5 85 L 232.5 88 L 248 88 L 248 96 L 256 96 L 256 88 L 280 88 L 280 96 L 288 96 L 288 99 L 280.5 99 L 280 102 L 272 102 L 271.5 99 L 232.5 99 L 230.5 102 L 232 102.5 L 231.5 104 L 248 104 L 248 112 L 231 111.5 L 231.5 110 L 226.5 112 L 226.5 111 L 228 110.5 L 225 109.5 L 227 109 L 226.5 107 L 225 107.5 L 225.5 105 Q 228.1 105.8 227 102.5 L 228.5 103 L 230 102.5 L 229 100.5 L 231 96.5 L 229 97.5 L 227.5 100 L 227 98 L 225 98.5 L 226 100.5 L 225 100.5 L 223.5 97 L 219.5 97 L 215 98.5 L 217.5 99 L 219 98.5 L 215.5 100 Q 212.5 98.5 215.5 97 L 219 96 L 219.5 93 L 221 93.5 L 220 91.5 L 221 88.5 L 220.5 87 L 223.5 88 L 223.5 87 L 219 85 L 217.5 88 L 216 87.5 L 222 81.5 L 222.5 79 Z M 230 104 L 229 107 L 231 107 Q 232 103 230 104 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 86 L 34 90.5 L 33 90.5 L 32.5 86 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 88 L 16 88 L 16 96 L 23.5 96 L 23.5 97 L 21 97 L 20.5 99 L 16 99 L 16 102 L 8 102 L 8 99 L 0 99 L 0 96 L 8 96 L 8 88 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 92 L 32 93.5 L 31.5 96 L 31 93.5 L 32.5 92 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 92 L 212.5 94 L 213.5 92 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 94 L 88 96.5 L 87 96.5 L 86.5 94 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210 95 Q 212.7 93.9 212 96.5 L 214 96.5 Q 210.9 98.3 212.5 100 L 210 101.5 L 213 102.5 L 213 104.5 L 212.5 106 L 211.5 104 L 207.5 113 Q 202.1 113.9 200 111.5 L 208 109.5 L 206 109 Q 205 106 208 107 L 208 104.5 Q 211.8 102.8 208.5 101 L 207 101.5 Q 206.3 99.3 208.5 100 L 210 100.5 L 211 97.5 L 208 98.5 L 210 95 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 98 Q 89.5 97.2 88 101 L 84 103.5 L 104 104 L 104 112 L 81.5 112 L 78.5 113 L 78.5 112 Q 81.5 112.9 80 108.5 L 81 106.5 L 80 103 Q 76.2 104.5 77 101.5 L 79.5 99 Q 85 100.5 86.5 98 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221 99 L 223 99.5 L 220.5 103 L 220 101.5 L 221 99 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 101 L 202.5 104 L 204.5 101 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 101 L 217 103.5 L 216 105.5 L 216.5 107 Q 213.8 105.8 216 104.5 L 215 102.5 L 216.5 101 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 104 L 16 104 L 16 112 L 8 112 L 8 104 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 104 L 280 104 L 280 112 L 256 112 L 256 104 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 105 L 76.5 107 L 77.5 105 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 106 L 29 108.5 L 27 111.5 L 26 111.5 L 25.5 108 L 24 108.5 L 25.5 106 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 107 L 197.5 109 L 198.5 107 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 107 Q 213.8 106.3 213 108.5 L 214.5 108 L 216 108.5 L 213.5 110 L 212 109.5 L 213 111.5 L 210.5 112 L 211 110.5 L 212 108.5 L 211.5 107 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131 108 L 134 109.5 Q 133.3 111.8 135.5 111 L 134.5 113 Q 130.8 113.8 130 111.5 L 131 108 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149 108 L 152 108.5 L 149.5 110 L 149 108 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157 108 L 160 108.5 L 160 110.5 Q 159.2 113.1 162.5 112 L 166.5 111 L 168 111.5 L 168 110 L 172 110 Q 170.8 113 174.5 112 L 174.5 113 L 163.5 112 L 157 113 L 156 110.5 L 157 108 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 108 L 173 108.5 L 169.5 109 L 169.5 108 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 108 L 188 108.5 L 185.5 109 L 185.5 108 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 108 L 192 109.5 Q 189.7 110.8 192.5 112 L 193.5 110 L 194 111.5 Q 192.5 114.5 186.5 113 L 186.5 112 L 190 111.5 L 185.5 111 L 182.5 112 L 180 110.5 L 182.5 110 L 184.5 110 Q 189.8 110.8 191.5 108 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 108 L 220.5 110 L 223.5 108 L 223.5 109 L 222 109.5 L 225 111.5 L 223.5 112 L 218.5 111 L 216.5 112 L 217.5 110 Q 220 110.7 219.5 108 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77 109 L 79 109.5 L 77 110.5 L 77 109 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 110 L 180 112.5 L 176 113 L 175.5 110 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 111 L 32 111.5 L 29.5 112 L 29.5 111 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 111 L 49 111.5 L 48.5 113 L 56 112.5 L 54 111.5 L 57 111 L 56 115 L 48 115 Q 49 112 46 113 L 46.5 111 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 111 L 72 112.5 L 70.5 113 L 68.5 111 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 112 L 40 112.5 L 34.5 113 L 34.5 112 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 117 L 55.5 117 L 56 119 L 48.5 119 L 48 117 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 120 L 16 120 L 16 128 L 8 128 L 8 120 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 120 L 51 121.5 Q 51.6 126.1 49 127.5 L 50 129.5 L 49 132.5 L 50.5 135 L 51 132 L 53 132.5 L 49.5 139 L 48 139.5 L 49 141.5 L 47.5 141 L 40.5 141 L 40 139 L 47.5 139 L 49 137.5 L 49 135.5 L 48 126.5 Q 51 125.3 50 121 L 48.5 120 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54 120 Q 56.7 121.9 63.5 121 L 65.5 120 L 68 120.5 L 66 124.5 L 68 125.5 Q 66.9 121.3 71 123 L 72 125.5 L 70 126 L 69.5 124 L 69 126.5 L 72 127.5 L 71 130 L 80.5 130 L 82.5 132 L 83 130.5 L 80 128.5 L 81.5 128 L 85.5 128 L 87 128.5 L 84 130.5 L 81.5 135 L 81 133.5 Q 83.2 132.3 80.5 131 L 80 134 L 71.5 134 L 71 136.5 L 70 136.5 L 67 128.5 L 69 129.5 L 70.5 134 L 71 131.5 L 68.5 127 L 65 126 L 65 123 L 56.5 123 L 56.5 124 L 63.5 124 L 64 126 L 56.5 126 L 55.5 125 L 52.5 130 L 53 128.5 L 52 124.5 L 54 120 Z M 65 121 L 66 123 Q 67 120 65 121 Z M 55 123 L 53 126 L 55 125 L 55 123 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 120 Q 93.5 119.2 92 123 L 95 123 L 95 126 L 89.5 125 L 89.5 127 Q 86.5 125.5 89.5 124 L 92 123.5 L 88 121.5 L 90.5 120 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94 120 Q 98.1 118.7 97 122 Q 92.9 123.3 94 120 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 120 L 113 121.5 L 112 124 Q 115.3 125.3 114 120.5 L 116.5 120 Q 119.1 119.2 118 122.5 L 117 122.5 L 116.5 121 L 113.5 125 L 108 122.5 L 109.5 123 Q 111.8 123.8 111 121.5 L 112.5 120 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 120 L 129 120.5 L 120.5 121 L 120.5 120 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 120 L 144 120.5 Q 144.8 122.8 142.5 122 L 137.5 123 L 137.5 122 L 141.5 120 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 120 L 162 120.5 L 160 123.5 L 161.5 127 L 164 125.5 Q 160.5 127 163 128.5 L 162.5 161 L 162 128.5 L 160.5 127 L 159.5 128 L 152 128 L 152 120 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 120 L 164 122 L 166 122 Q 164.7 126.1 168 125 L 167 121 L 165 120.5 L 166.5 120 L 169.5 125 L 171 124.5 Q 170.2 127.1 173.5 126 L 173.5 127 L 172 127.5 L 173.5 130 L 176 129.5 Q 175.4 126.8 181.5 128 L 181.5 129 L 179 130.5 L 184 132 Q 185.4 136 178.5 134 L 176.5 133 L 175 133.5 L 173 130.5 L 171 126 L 168.5 125 L 165 126 L 164.5 123 L 163 123.5 L 163.5 120 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 120 L 173 120.5 L 171 121.5 L 171.5 123 Q 169.3 123.8 170 121.5 L 171.5 120 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 120 L 175 121.5 L 176 123.5 L 172.5 125 L 172.5 124 L 174 123.5 Q 171.2 121.8 175.5 120 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 120 L 185.5 123 L 186.5 120 L 188.5 123 L 189 121.5 L 188.5 120 L 190.5 121 L 191.5 120 L 194 121.5 Q 193.3 119.3 195.5 120 L 197 123.5 L 196 123.5 L 195.5 121 Q 192.8 122.2 195 123.5 L 193.5 126 L 191.5 125 L 190 126.5 L 190 144.5 L 189 146.5 L 190 148.5 L 186.5 151 L 182 145.5 L 185 146.5 L 185.5 145 L 188 146.5 L 187 144.5 L 189 144.5 L 188.5 126 L 188 136 L 186 135.5 L 186 127.5 L 184 127.5 L 185 124.5 L 184.5 120 Z M 192 122 L 191 123 Q 188 122 189 126 L 192 124 L 192 122 Z M 187 123 L 186 126 L 188 126 L 187 123 Z M 186 147 L 187 150 Q 189 151 188 148 L 186 147 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 120 L 202.5 120 L 204.5 121 L 206 120.5 L 206 122 L 202 122 L 202 124.5 L 201 125.5 L 201 144 L 203 144.5 L 203 152 L 201 152.5 L 201 159.5 L 202.5 162 Q 205.4 158.9 204.5 152 L 205 159.5 L 205 161.5 L 204.5 165 L 203.5 162 L 202.5 166 L 200.5 160 L 200 162 L 197.5 161 L 196.5 165 L 196 128.5 L 197 126.5 L 196.5 125 L 198 125.5 Q 197.2 122.5 201 124 L 201 121.5 L 200 121.5 L 199.5 123 L 198.5 120 Z M 198 128 L 197 160 L 199 160 L 198 128 Z M 201 144 L 200 152 L 201 152 L 201 144 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 120 L 216 120.5 L 207.5 121 L 207.5 120 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 120 L 227 120.5 L 225 121 L 224.5 123 L 216.5 123 L 216.5 124 L 225.5 124 L 226.5 125 L 227 122 Q 229.7 123.1 229 120.5 L 230 120.5 L 226.5 126 L 205 126 L 205 143.5 L 204 143.5 L 203.5 127 L 202 127.5 L 203 123 L 208.5 122 L 224 122 L 224 120 Z M 204 124 L 204 126 L 206 125 L 204 124 Z M 227 131 L 226 133 L 229 134 L 227 131 Z M 217 140 L 216 142 L 224 142 L 225 141 L 228 143 L 228 142 L 227 140 L 217 140 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 120 L 248 120.5 L 232 121.5 L 256 122 L 256 120 L 261 120 L 261.5 124 L 264 123 L 262.5 127 L 260 127.5 Q 261.2 130.3 262.5 128 L 264 128.5 L 261 130.5 L 262 133 Q 264.7 131.9 264 134.5 L 262 134.5 L 261.5 136 L 260.5 133 L 259.5 136 L 257 135.5 L 256.5 134 L 255 134.5 L 256 132.5 L 254 131.5 L 257 131 Q 255.5 134.7 258.5 134 Q 261 133 260 128.5 L 258 128.5 L 259 126 L 232.5 126 L 232 122.5 Q 229.8 121.3 232.5 120 Z M 258 121 L 256 123 L 258 123 L 258 121 Z M 260 121 L 259 124 L 256 125 L 260 126 L 263 126 L 260 125 L 260 121 Z M 249 123 L 249 124 L 256 124 L 249 123 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262 120 L 264 120.5 L 262 121.5 L 262 120 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 120 L 280 120 L 280 128 L 272 128 L 272 120 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 121 Q 104.1 120.2 103 123.5 Q 101.4 126.5 96 125 L 96.5 123 L 98.5 124 L 102 122.5 L 101.5 121 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 121 L 135.5 123 Q 136.8 125.3 141.5 124 L 143 125.5 L 141.5 126 L 138.5 125 L 138.5 126 L 141 127.5 L 139.5 127 L 136 125.5 Q 136.8 123.3 134.5 124 L 130 122.5 L 132.5 121 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 122 L 107 122.5 L 105 123.5 L 108 124.5 L 105.5 126 L 104 123.5 L 105.5 122 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 122 L 127.5 122 Q 126.5 125 131.5 124 L 132.5 126 L 118.5 126 L 117.5 125 L 115.5 126 L 116.5 124 L 120.5 122 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 123 L 231 124.5 L 229.5 127 L 229 125.5 L 230.5 123 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 125 L 109.5 127 L 112.5 126 L 112.5 127 L 111 127.5 L 113.5 128 L 116 127 L 116 163.5 L 115 165.5 L 118 167.5 L 116.5 168 L 114.5 167 L 111.5 168 L 111.5 167 Q 115.7 168.3 114 163.5 L 112.5 161 L 110.5 162 L 108 161.5 L 110.5 158 L 113.5 161 L 115 159.5 L 115 136.5 L 112 136 L 112 131.5 L 111 131.5 L 109.5 134 L 110 132.5 L 108 126.5 L 109.5 125 Z M 110 129 L 110 131 L 112 130 L 110 129 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 128 L 152 131 Q 149.3 129.9 150 132.5 L 152 132.5 L 151 136 L 161 136 L 161 144 L 152.5 144 L 151 142.5 Q 148.1 138.9 149 131.5 L 150.5 128 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 128 L 232 133.5 L 232 135.5 L 231.5 137 L 230.5 135 L 230 138 Q 233.3 136.7 232 141.5 L 231 144.5 L 232.5 146 L 240 146 L 240.5 135 L 241 160.5 L 240 160.5 L 240 150 L 232.5 150 L 228.5 152 L 226.5 151 L 224.5 152 L 224 149.5 L 226 147.5 L 225 146.5 L 225.5 145 L 226 147 L 228 146.5 L 224.5 142 L 223.5 143 L 213.5 143 L 214.5 140 L 213 139.5 L 223.5 139 L 226 138 L 225.5 135 L 225 137 L 216.5 137 L 215.5 136 L 214 136.5 L 213 131.5 L 214 131.5 L 214.5 133 Q 216.3 129.3 223.5 131 L 223.5 132 L 216.5 132 L 216 134 L 226 133.5 L 225 131.5 L 226.5 129 L 227 131 Q 229.7 132.1 229 129.5 L 228.5 128 Z M 228 135 L 228 137 L 227 140 L 231 141 Q 232 138 229 139 L 229 135 L 228 135 Z M 229 144 L 229 147 L 231 146 L 229 144 Z M 227 148 L 225 150 L 227 150 L 227 148 Z M 230 148 L 231 150 Q 232 147 230 148 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 131 L 241 131.5 L 232.5 132 L 232.5 131 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 131 L 252 131.5 L 249.5 132 L 249.5 131 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 132 L 212 134.5 L 211 134.5 L 211.5 132 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 133 L 99 134.5 L 97.5 135 L 96.5 133 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 133 L 107 135.5 L 105.5 136 L 103.5 135 L 101 136.5 L 102 134 L 100.5 133 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 133 L 254 134.5 L 251 136.5 L 251 159.5 L 249 160 L 249 136.5 L 250 135.5 Q 247.7 134.3 250.5 133 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 134 L 95.5 139 L 98.5 137 L 99 139 L 103.5 137 L 103 140.5 L 104.5 144 L 107.5 146 L 108.5 144 L 109.5 146 L 110.5 144 Q 114 146 109.5 148 L 101 142.5 L 103 139.5 L 101.5 139 L 99 140.5 L 99.5 142 L 94 140 L 93 137.5 L 94.5 134 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 134 L 127 144 L 129.5 143 L 131 143.5 L 130 141.5 L 133 139.5 L 132 142.5 L 134 141.5 L 134.5 140 L 135 141.5 L 130.5 145 L 128.5 145 L 126 144.5 L 126.5 134 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 134 L 130.5 135 L 132.5 135 L 135 136.5 Q 135.8 138.8 133.5 138 L 132.5 137 L 129 139.5 L 130 136.5 L 128.5 134 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 135 L 171 137.5 L 169 136.5 L 169.5 135 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 135 L 248 163.5 L 247 163.5 L 247.5 135 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 136 L 16 136 L 16 144 L 8 144 L 8 136 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 136 L 181.5 139 L 182 137.5 L 181.5 136 L 184 136.5 L 183 138.5 L 185 139 L 185 141 Q 182.3 139.9 183 142.5 L 183.5 144 L 181 142.5 L 183 139.5 L 180.5 141 L 178 138.5 L 177.5 136 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 136 L 255 159.5 L 256 160.5 L 256 168 L 253 168 L 253 160.5 L 254 159.5 L 254.5 136 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 136 L 280 136 L 280 144 L 272 144 L 272 136 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 137 L 62 140.5 L 60.5 141 Q 57.8 139.8 60 138.5 L 60.5 137 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 137 Q 151.3 142.5 150 152 L 159.5 152 L 160 155 Q 152 156.7 149 152.5 L 148.5 143 L 145 143.5 L 145 141.5 L 145.5 139 L 147.5 143 L 148 140.5 L 147.5 137 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 138 L 72 140 L 77.5 138 L 76.5 140 L 72.5 142 L 71.5 138 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 138 L 83 141.5 Q 81.3 139.9 79.5 143 L 78 143.5 L 78.5 145 L 75.5 147 L 74 147.5 L 79.5 140 Q 82 140.7 81.5 138 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 138 L 212 142.5 L 211 142.5 L 211.5 138 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 139 L 173 141 L 172.5 143 L 169.5 139 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186 139 Q 189 138 188 141 Q 185 142 186 139 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 142 Q 172.3 143.3 170 144.5 L 169.5 164 L 169.5 142 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 143 L 48 144.5 L 47.5 147 L 47 144.5 L 48.5 143 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 143 L 63 143.5 L 60.5 144 L 60.5 143 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 143 L 82.5 145 L 83.5 143 L 86.5 147 L 88 147.5 L 86 148.5 L 89 150 L 89.5 148 L 93 150.5 L 91.5 151 L 89.5 150 L 90.5 152 L 94 153.5 L 89.5 156 L 89.5 154 L 87 155.5 L 88 157.5 L 86 156.5 Q 86.8 154.3 84.5 155 L 83 154.5 Q 83.8 156.8 81.5 156 L 81.5 158 L 79.5 158 L 77 156.5 L 79 156.5 L 78 154.5 L 81 153.5 L 79 152.5 L 80 151.5 L 77.5 148 L 79.5 149 L 81.5 143 Z M 84 145 L 83 147 L 86 148 L 84 145 Z M 83 149 L 83 150 L 85 150 L 83 149 Z M 86 150 L 87 152 Q 88 149 86 150 Z M 83 151 L 84 153 Q 85 150 83 151 Z M 89 151 L 87 153 L 88 154 L 90 153 L 89 151 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 144 L 42 145.5 L 39.5 150 L 0.5 150 L 0 146 L 40.5 146 L 41.5 144 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 145 L 58 148.5 Q 58.8 150.8 56.5 150 L 58 147.5 Q 57.3 145.3 59.5 146 L 60.5 145 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 145 Q 65 146.2 64 150 L 61.5 149 L 59.5 150 L 60.5 148 Q 63.8 149.1 63 146.5 L 62.5 145 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 146 L 44 148 L 42 147.5 L 43.5 146 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 146 L 160 146 L 160 150 L 152 150 L 152 146 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 146 L 287.5 146 L 288 150 L 256.5 150 L 256 146 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 147 L 178.5 150 L 176 148.5 L 177 150.5 L 176.5 153 L 175 152.5 L 175 162 L 171 162 L 171 152.5 L 173 152 L 173 159.5 L 172 160.5 L 174 161 L 174 151.5 L 172 149.5 L 176.5 147 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 148 L 111 149.5 L 110.5 151 L 109.5 149 L 111.5 148 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 148 L 215 148.5 L 212 149 L 211.5 151 L 211 149.5 L 212.5 148 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 149 L 138.5 152 L 137 151.5 L 140.5 149 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 149 L 141.5 152 L 143.5 149 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 150 L 45 151.5 L 45 155 Q 42.3 153.9 43 156.5 L 44 157.5 Q 40.9 159.3 42.5 161 L 32 162 L 32.5 160 L 39.5 160 L 41 160.5 L 40 155 Q 43.7 156.5 43 153.5 L 42 151 L 45.5 150 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 150 L 76.5 152 L 78 151.5 L 76.5 155 L 75.5 150 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 150 L 216 150.5 L 216 160.5 L 214.5 160 L 213 159.5 L 213 151.5 L 214.5 150 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 151 L 97 152 L 97 154 Q 99.7 152.9 99 155.5 L 99.5 157 L 97.5 156 Q 96.3 158.3 95 155.5 L 97 155.5 L 94.5 151 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 151 L 180.5 153 L 179 152.5 L 181.5 157 L 182 155.5 L 181.5 154 L 187 161.5 L 184 162 L 183.5 158 L 182 161.5 Q 180.7 166.3 183 167.5 L 175.5 168 L 173.5 168 Q 170.2 169.1 171 166.5 L 173 166.5 Q 171.5 161.3 176 163 Q 177.1 165.7 174.5 165 L 174.5 166 Q 178.7 167.3 177 162.5 L 176 160.5 L 176 158.5 L 177 155.5 L 176.5 154 Q 178.8 154.8 178 152.5 L 179.5 151 Z M 181 158 L 180 160 L 182 159 L 181 158 Z M 180 162 L 178 165 L 181 166 L 181 162 L 180 162 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 152 L 136 155 L 128 154.5 Q 133.8 155.3 135.5 152 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 152 L 189.5 155 L 187.5 152 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 152 L 212 160.5 L 211 160.5 L 211.5 152 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 153 L 127 156 L 143.5 155 L 146 156 Q 147.1 158.7 144.5 158 Q 142.7 155.2 136.5 157 L 127 159 L 127.5 165 L 128 160 L 139.5 159 L 139.5 160 L 136 160 L 136 168 L 128 168 L 127.5 166 L 122.5 168 L 122.5 167 L 126 165.5 L 126 158 L 130.5 158 L 130.5 157 Q 123.5 159 126.5 153 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 156 L 190.5 158 L 189.5 156 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 157 L 95 158.5 L 91.5 159 L 89.5 157 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 158 L 67 158.5 L 64.5 160 L 63.5 159 L 54.5 159 L 53 159.5 L 54.5 158 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 159 L 82 161.5 L 81 163.5 L 81.5 165 Q 78.8 163.8 81 162.5 L 80.5 161 Q 79.3 163.3 78 160.5 Q 79.8 162.1 81.5 159 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 160 L 16 160 L 16 168 L 8 168 L 8 160 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 160 L 66.5 162 L 65 162.5 L 65.5 164 Q 63.3 164.8 64 162.5 L 67.5 160 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 160 L 147.5 162 L 150.5 160 L 149.5 162 L 148 162.5 L 150 167 L 152 167.5 L 150.5 168 L 146.5 168 L 144 167.5 L 146 166.5 L 144 163.5 L 146 163 L 146.5 160 Z M 147 163 L 146 166 L 148 166 L 149 167 L 148 165 Q 149 162 147 163 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 160 L 158.5 162 L 159.5 160 L 160.5 162 Q 158.3 161.3 159 163.5 L 163 165 L 162.5 167 L 160.5 166 L 160.5 168 L 158.5 167 L 157 167.5 L 157.5 166 L 155.5 167 L 158 163.5 Q 158.8 161.3 156.5 162 L 155.5 160 Z M 159 164 Q 157 167 160 166 L 159 164 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 160 L 231 163.5 L 229 162.5 L 229.5 160 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 160 L 280 160 L 280 168 L 272 168 L 272 160 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 161 Q 57.5 160.1 56 164.5 L 55 164.5 L 54.5 161 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 162 L 54 164.5 L 52 168 L 49 167.5 L 53 164.5 L 52.5 162 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 163 Q 110.8 162.3 110 164.5 L 108.5 163 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 163 L 113 166 L 111 165.5 L 111.5 163 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 163 L 186.5 163 L 189 164.5 L 186.5 168 L 186 166 L 184 165.5 L 184.5 163 Z M 186 164 Q 185 167 188 166 Q 189 163 186 164 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 163 L 201 164.5 Q 198.8 165.8 201.5 167 L 205.5 166 L 206.5 168 L 204.5 167 L 201.5 168 L 199.5 168 L 196.5 167 L 195 167.5 L 200 164.5 L 198.5 163 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 165 L 65.5 167 L 64.5 165 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 165 L 109.5 168 L 107 167.5 L 107.5 165 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 165 L 232 167.5 L 231 167.5 L 230.5 165 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 165 L 248 166.5 L 245.5 168 L 245.5 167 Q 248 167.7 247.5 165 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 166 L 40.5 166 L 42 167.5 L 39.5 168 L 32.5 168 L 32 166 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 166 L 54.5 168 L 53 167.5 L 55.5 166 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 166 L 74.5 167 Q 75.8 164.8 77 167.5 L 74.5 168 L 69.5 167 L 68 167.5 L 69.5 166 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 166 L 86 166.5 Q 83.9 169.8 83.5 166 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 166 L 102.5 168 L 100 167.5 L 103.5 166 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 166 L 170 168 L 164 167.5 L 169.5 166 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 166 L 230 167.5 L 228.5 168 L 226 167.5 L 227.5 166 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 167 L 98 167.5 L 89.5 168 L 89.5 167 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 167 L 213 167.5 L 210.5 168 L 210.5 167 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 167 L 225 167.5 L 216.5 168 L 216.5 167 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 169 L 95.5 170 Q 97.2 167.3 103.5 169 L 104.5 170 L 112 170 L 111.5 172 L 88.5 172 L 87.5 171 L 72.5 171 L 71.5 172 L 64 172 L 64.5 170 L 71.5 170 L 72.5 169 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 169 L 159.5 169 L 160 171 L 152.5 171 L 152 169 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 169 L 231.5 169 L 232 171 L 216 172 L 216.5 170 L 223.5 170 L 224.5 169 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 170 L 55.5 170 L 56 172 L 48.5 172 L 48 170 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 174 L 87.5 174 L 96 175.5 L 88 176 L 88 184 L 80 184 L 80 176 L 87.5 176 L 87.5 175 L 72.5 175 L 71.5 176 L 64 176 L 64 184 L 56 184 L 56 176 L 48.5 176 L 48.5 175 L 63.5 176 L 72.5 174 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 174 L 160 174.5 L 152.5 175 L 152.5 174 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 174 L 232 174.5 L 224 175.5 L 232 176 L 232 184 L 224 184 L 224 176 L 216.5 176 L 216.5 175 Q 222.7 176.8 224.5 174 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 175 L 112 175.5 L 104.5 176 L 104.5 175 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 176 L 16 176 L 16 184 L 8 184 L 8 176 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 176 L 136 176 L 136 184 L 128 184 L 128 176 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 176 L 160 176 L 160 184 L 152 184 L 152 176 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200 176 L 208 176 L 208 184 L 200 184 L 200 176 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272 176 L 280 176 L 280 184 L 272 184 L 272 176 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8 192 L 32 192 L 32 200 L 8 200 L 8 192 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40 192 L 64 192 L 64 200 L 40 200 L 40 192 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 192 L 104 192 L 104 200 L 80 200 L 80 192 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 192 L 136 192 L 136 200 L 112 200 L 112 192 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 192 L 176 192 L 176 200 L 152 200 L 152 192 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184 192 L 208 192 L 208 200 L 184 200 L 184 192 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 192 L 248 192 L 248 200 L 224 200 L 224 192 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 192 L 280 192 L 280 200 L 256 200 L 256 192 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 287.5 0 L 288 0.5 L 288 56 L 248.5 56 L 248 58 L 255.5 58 L 256.5 59 L 279.5 59 Q 281.3 56.3 287.5 58 L 287.5 59 L 280.5 59 L 280 61 L 288 61.5 L 280.5 62 L 279.5 61 L 256.5 61 L 255.5 62 L 248 62 L 248.5 64 L 288 64 L 288 96 L 280 96 L 280 88.5 L 279.5 88 L 256 88 L 256 96 L 248 96 L 248 88 L 232.5 88 L 232 85 L 224.5 85 L 224 83 L 232 83 L 232.5 80 L 248 80 L 248 72 L 241 72 L 241 65.5 L 241 63.5 L 240 59.5 L 241 54.5 L 240.5 52 Q 237.9 52.7 239 50 Q 242 51 241 48 L 245 48 L 245 45.5 L 246 45.5 Q 244.7 49.7 249.5 48 L 251 46.5 L 251 38.5 L 250 38.5 L 247.5 44 L 246.5 42 L 248 42.5 L 247 40.5 Q 249.6 39.1 249 34.5 L 248.5 33 L 252 35.5 L 252.5 39 L 254 34.5 L 251 32.5 L 256 32 L 257 26.5 L 255 18.5 Q 258.8 16.8 255.5 15 L 208.5 15 L 204.5 16 Q 203.2 13.7 198.5 15 L 196 20 L 191 20 L 191 22.5 L 191.5 24 L 190 24.5 L 190 31.5 L 189 31.5 L 189 24 L 185 24 L 185 31.5 L 183.5 33 L 179 32 Q 177.5 35.8 180.5 35 L 182 35.5 Q 181.3 33.3 183.5 34 L 184.5 36 L 182 36.5 L 182.5 38 L 181 38.5 L 182 42.5 L 179.5 41 L 177.5 42 L 176 38 L 172 36.5 Q 173.3 33.8 174.5 36 Q 176.8 35.3 176 37.5 L 177 40 Q 180.3 41.3 179 36.5 L 176 34.5 Q 178.3 33.3 175.5 32 L 168 31 L 167.5 24 L 163 27.5 Q 166.2 29.8 165 36.5 L 164 39 L 161 38.5 L 163 36.5 L 164 30 L 160 29 Q 158.9 26.3 161.5 27 L 165 24.5 L 160 24 L 160 21 L 155 21 L 155 19.5 Q 158.1 17.8 156.5 16 Q 160.9 14.5 160 17.5 L 161 17.5 L 161.5 16 L 176 16 L 176 8 L 152.5 8 L 152 8.5 L 152 15.5 L 150.5 16 L 150.5 17 L 154 18.5 L 152.5 19 L 149 18 L 149 15 L 140.5 15 L 135.5 16 Q 134 13.5 128.5 15 L 125.5 16 Q 123.7 13.3 117.5 15 L 111 16 L 110.5 18 L 110 16 L 105 16.5 Q 107.3 17.8 104.5 19 L 103.5 16 Q 98 14.5 96.5 17 L 96 15 Q 90.8 12.9 92 17.5 L 88.5 15 Q 79.6 13.6 76 17.5 L 80 19.5 L 72.5 22 L 70.5 21 L 66.5 24 L 56 24.5 L 64 25.5 L 56 26 L 56 30 L 62.5 30 L 64 29.5 Q 64.9 32.5 60.5 31 L 58.5 31 L 55.5 32 L 52.5 31 L 50.5 32 L 48.5 31 L 47 34.5 L 48 37 L 50.5 36 L 53.5 41 Q 56.1 40.2 55 43.5 L 51 44.5 L 50 39 L 47 40.5 L 47 51.5 L 48 52.5 L 47 56 L 41 56 L 41 62.5 L 39.5 62 Q 33.3 63.8 31.5 61 L 8.5 61 Q 6.7 63.8 0.5 62 L 0.5 61 L 7.5 61 L 8 59 L 0 58.5 L 7.5 58 L 8.5 59 L 31.5 59 L 32.5 58 L 40 58 L 39.5 56 L 0 56 L 0 0 Z M 8 8 L 8 16 L 32 16 L 32 8 L 8 8 Z M 40 8 L 40 16 L 64 16 L 64 8 L 40 8 Z M 209 8 L 209 9 L 216 9 L 209 8 Z M 225 8 L 225 9 L 232 9 L 225 8 Z M 264 8 L 264 16 L 280 16 L 280 8 L 264 8 Z M 208 10 L 208 14 L 216 14 L 216 10 L 208 10 Z M 224 10 L 224 14 L 232 14 L 232 10 L 224 10 Z M 193 15 L 191 17 L 195 18 Q 197 14 193 15 Z M 64 16 L 64 19 Q 68 20 67 17 L 69 17 L 64 16 Z M 73 16 L 71 17 L 69 20 L 73 21 L 75 20 Q 77 21 76 19 L 73 16 Z M 66 20 L 64 22 L 66 22 L 66 20 Z M 8 24 L 8 32 L 16 32 L 16 24 L 8 24 Z M 272 24 L 272 32 L 280 32 L 280 24 L 272 24 Z M 254 39 Q 251 42 252 48 L 256 49 L 257 48 L 257 40 L 256 40 Q 257 43 254 42 L 254 39 Z M 8 40 L 8 48 L 16 48 L 16 40 L 8 40 Z M 272 40 L 272 48 L 280 48 L 280 40 L 272 40 Z M 32 59 L 33 61 L 40 61 L 40 59 L 32 59 Z M 248 59 L 249 61 L 256 61 L 256 59 L 248 59 Z M 105 61 L 103 63 L 105 65 L 110 65 L 109 62 L 105 61 Z M 256 72 L 256 80 L 280 80 L 280 72 L 256 72 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 17 L 117 17.5 L 113.5 18 L 113.5 17 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 19 L 91 19.5 L 88.5 20 L 88.5 19 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 27 L 252.5 29 L 253.5 27 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 32 Q 190 33 189 37.5 L 188 37.5 L 187.5 32 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 33 L 57 35.5 L 55 34.5 L 55.5 33 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 39 Q 174.3 40.3 173 45.5 L 172 45.5 L 170.5 43 Q 167.5 43.7 169 40 L 171.5 39 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 45 L 183 47.5 L 182 47.5 L 182.5 45 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 47 L 173 48.5 L 172 51 L 169 49.5 L 172 48.5 L 172.5 47 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177 50 L 179 50.5 L 178 53.5 L 178.5 55 L 176 54 Q 175.3 57.1 178 56.5 L 178 61.5 L 177 61.5 Q 177.8 57.8 175.5 57 L 174.5 59 L 173 52 L 176.5 53 L 177 50 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 52 L 182 54.5 L 181 54.5 L 181.5 52 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 55 L 239 60.5 L 237 61 L 236 57.5 L 237.5 55 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 56 L 102 61 L 107 58.5 L 108.5 56 L 108 57.5 L 107 60.5 L 108.5 61 Q 109.8 58.7 111 61.5 L 111 71.5 L 113 80.5 L 111.5 80 L 104 80 L 104 83 L 111.5 83 L 112 85 L 104 85 L 104 88 L 112 88 L 112 92.5 L 111 96 L 104 96 L 104 88 L 96 88 L 96 80 L 104 80 L 104 72 L 96 72 L 96 67.5 L 95.5 66 L 97 66.5 L 97 65 Q 100.8 66.5 100 63.5 Q 102.3 62.2 99.5 61 Q 95.8 59.8 97 63.5 L 96 63.5 L 97.5 60 Q 101.9 61.5 101 58.5 L 100.5 56 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 62 L 176 63.5 L 174.5 64 L 173.5 62 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 63 L 93.5 65 L 92.5 63 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 64 L 31.5 64 L 32 67 Q 37.2 65.3 36 69 L 32 69 L 31.5 72 L 8 72 L 8 80 L 30.5 80 L 31 85 L 32.5 85 L 32 86.5 L 33 91.5 Q 30.3 92.6 31 96 L 28 96 L 28 103.5 L 26 104 L 26 96 L 16 96 L 16 88 L 8 88 L 8 96 L 0 96 L 0 64 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 64 Q 239.8 65.9 238 72 L 236 72 L 236 77 L 234 77 L 233 74.5 L 236 71.5 L 236.5 64 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 66 L 180.5 68 L 178.5 69 L 179 67.5 L 179.5 66 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 68 L 174 70.5 L 173 70.5 L 173.5 68 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 71 Q 40.9 70.1 39 75.5 L 36.5 80 Q 33.1 80.9 35 75.5 L 37.5 71 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 73 L 114.5 75 L 113.5 73 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 73 L 228 73.5 L 225.5 75 L 226.5 73 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 77 L 90.5 81 L 92.5 77 L 93 79.5 L 92 85 Q 88.7 86.3 90 81.5 Q 86.9 80.4 88.5 77 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 80 L 95 82.5 L 94 82.5 L 94.5 80 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 84 L 35 87.5 L 34 87.5 L 34.5 84 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 84 L 87 86 L 85 85.5 L 86.5 84 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 87 L 90 94.5 Q 87.8 95.8 90.5 97 L 96 96 L 96.5 99 L 114.5 99 L 117 99.5 L 113.5 108 L 112 107.5 Q 109.8 114.3 116.5 112 L 117.5 109 Q 123.2 110.3 124.5 107 L 125 109.5 L 126.5 113 L 129.5 112 L 134.5 113 L 137.5 112 L 139.5 112 L 143.5 113 L 144.5 112 L 156.5 112 Q 157.8 114.3 162.5 113 L 162.5 111 Q 166.5 114 174.5 113 L 176.5 113 L 185.5 112 Q 187 114.5 192.5 113 L 193.5 112 L 201.5 112 Q 202.8 114.3 207.5 113 L 208.5 112 L 227.5 112 L 228.5 111 L 229.5 112 L 248 112 L 248 104 L 256 104 L 256 112 L 280 112 L 280 104 L 272.5 104 L 272 102 L 279.5 102 L 280.5 104 L 288 104 L 288 144 L 280 144 L 280 136 L 272 136 L 272 144 L 256.5 144 L 256.5 145 L 288 145.5 L 256 146 L 256.5 150 L 287.5 150 L 287.5 151 L 256 151.5 L 288 152 L 288 204.5 L 287.5 205 L 0 205 L 0 152 L 40 152 L 41 154.5 L 40 159.5 L 40.5 161 L 39.5 160 L 32 160 L 32.5 162 L 39.5 162 L 39.5 163 L 32.5 163 L 32 165 L 40 165.5 L 32 166 L 32.5 168 L 47.5 168 Q 49.3 170.7 55.5 169 L 56 166.5 L 56 160 L 64.5 160 L 64 161.5 L 64 169 L 71.5 169 L 71.5 170 L 64 170 L 64 174 L 71.5 174 L 72.5 173 L 87.5 173 Q 89.2 175.7 95.5 174 Q 97.2 171.2 103.5 173 L 104.5 174 L 112 174 L 112 170 L 104.5 170 L 104.5 169 L 111.5 169 L 119.5 167 L 120.5 168 L 136 168 L 136 160 L 139.5 160 L 141.5 160 L 144 160 L 144 168 L 151.5 168 L 153 167.5 L 152 171 L 159.5 171 L 160 168 L 162.5 168 L 164.5 168 L 190.5 168 L 191.5 167 L 193.5 168 L 195.5 168 L 212.5 168 L 213.5 167 L 216 167.5 L 216.5 169 L 223.5 169 L 223.5 170 L 216 170 L 216 174 L 232 172.5 L 224 171.5 L 232 171 L 231 165.5 L 232 163.5 L 232 161.5 L 231.5 160 L 229.5 160 L 216 161 L 216 152 L 226.5 152 L 228.5 152 L 240 152 L 240 168 L 249 168 L 249 160.5 L 251 159.5 L 251 136.5 Q 252.5 133.5 254 136.5 L 253.5 160 L 252.5 136 L 252 159.5 L 251 160.5 L 251 168 L 256 168 L 256 160.5 L 255 159.5 L 255 136 L 263.5 136 L 264 133.5 L 264 131.5 Q 265.7 126.7 261.5 128 L 261.5 127 Q 266.1 128.3 264 122.5 L 262 122.5 L 263.5 120 L 256.5 120 L 247.5 122 L 232.5 122 L 232.5 121 L 248 120.5 L 224.5 120 L 215.5 122 L 207.5 122 L 207.5 121 L 216 120.5 L 198.5 120 L 196.5 120 L 192.5 121 L 191.5 120 L 184 120 L 185 126.5 L 184.5 128 L 186 128.5 L 186 136 L 181 134.5 L 184 134 Q 185.3 131 181.5 132 L 179 130.5 L 182 128.5 L 176 128 L 176 120 L 163.5 120 L 161.5 120 L 152 120 L 152 128 L 161 128.5 Q 158.8 129.7 160 134.5 L 160.5 136 L 152 136 L 152 132.5 L 152 130.5 L 151.5 128 L 144.5 128 Q 141.8 126.8 144 125.5 L 144 120 L 141.5 120 L 139.5 121 Q 138.3 118.7 133.5 120 L 131.5 120 L 129.5 121 L 128.5 120 L 111.5 120 L 109.5 120 L 99 120.5 L 99.5 122 Q 98.3 119 94 120 Q 95.1 122.7 92.5 122 L 92.5 120 L 88 121 L 89 126.5 L 87.5 128 L 72 128 L 72 120 L 64.5 120 L 63.5 121 L 56 121 L 56 113.5 L 57.5 112 L 64.5 113 L 69.5 112 Q 70.8 114.3 75.5 113 L 77.5 112 L 80.5 113 L 81.5 112 L 104 112 L 104 104 L 110.5 104 L 111 102.5 L 111.5 101 L 96.5 101 L 96 104 L 88 104 Q 89.1 101.3 86.5 102 L 84 103.5 L 88 101 Q 89.5 97.3 86.5 98 L 84.5 99 L 84.5 98 L 88 97 L 89.5 87 Z M 113 100 L 113 101 L 115 101 L 113 100 Z M 112 102 L 114 106 L 115 104 L 112 102 Z M 8 104 L 8 112 L 16 112 L 16 104 L 8 104 Z M 124 109 L 123 112 L 124 112 L 124 109 Z M 119 110 L 119 111 L 121 111 L 119 110 Z M 8 120 L 8 128 L 16 128 L 16 120 L 8 120 Z M 272 120 L 272 128 L 280 128 L 280 120 L 272 120 Z M 183 129 L 181 131 L 184 131 Q 185 128 183 129 Z M 8 160 L 8 168 L 16 168 L 16 160 L 8 160 Z M 272 160 L 272 168 L 280 168 L 280 160 L 272 160 Z M 48 170 L 48 174 L 56 174 L 56 170 L 48 170 Z M 153 172 L 153 173 L 160 173 L 153 172 Z M 73 174 L 73 175 L 88 175 L 73 174 Z M 153 174 L 153 175 L 160 175 L 153 174 Z M 225 174 L 225 175 L 232 175 L 225 174 Z M 49 175 L 49 176 L 56 176 L 49 175 Z M 65 175 L 65 176 L 72 176 L 65 175 Z M 89 175 L 89 176 L 112 176 L 89 175 Z M 217 175 L 217 176 L 224 176 L 217 175 Z M 8 176 L 8 184 L 16 184 L 16 176 L 8 176 Z M 56 176 L 56 184 L 64 184 L 64 176 L 56 176 Z M 80 176 L 80 184 L 88 184 L 88 176 L 80 176 Z M 128 176 L 128 184 L 136 184 L 136 176 L 128 176 Z M 152 176 L 152 184 L 160 184 L 160 176 L 152 176 Z M 200 176 L 200 184 L 208 184 L 208 176 L 200 176 Z M 224 176 L 224 184 L 232 184 L 232 176 L 224 176 Z M 272 176 L 272 184 L 280 184 L 280 176 L 272 176 Z M 8 192 L 8 200 L 32 200 L 32 192 L 8 192 Z M 40 192 L 40 200 L 64 200 L 64 192 L 40 192 Z M 80 192 L 80 200 L 104 200 L 104 192 L 80 192 Z M 112 192 L 112 200 L 136 200 L 136 192 L 112 192 Z M 152 192 L 152 200 L 176 200 L 176 192 L 152 192 Z M 184 192 L 184 200 L 208 200 L 208 192 L 184 192 Z M 224 192 L 224 200 L 248 200 L 248 192 L 224 192 Z M 256 192 L 256 200 L 280 200 L 280 192 L 256 192 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 89 L 119.5 91 L 118.5 89 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 90 L 221 92.5 L 220.5 94 L 219 93.5 L 218.5 96 L 218 93.5 L 220.5 90 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 92 L 116 94.5 L 115 94.5 L 115.5 92 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 99 L 7.5 99 L 8 101 L 0.5 101 L 0 99 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16 99 Q 21.2 97.3 20 101 Q 16.7 99.9 18 104 L 20 104.5 L 20 112 L 33.5 112 Q 34.8 114.3 39.5 113 L 41.5 113 L 45.5 112 L 48 113 L 48 123.5 L 49 125.5 L 48 126.5 L 48 137 L 40 137 L 40 143 L 48 143.5 L 43 144.5 L 43.5 146 Q 41.5 142 39.5 146 L 0 145.5 L 40 144.5 L 16 144 L 16 136 L 8 136 L 8 144 L 0 144 L 0 104 L 7.5 104 L 8.5 102 L 16 102 L 16 99 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232 99 L 271.5 99 L 272 101 L 232.5 101 L 232 99 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280 99 L 287.5 99 L 288 101 L 280.5 101 L 280 99 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201 104 L 204 104.5 L 201.5 106 L 201 104 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 105 Q 209.1 104.3 208 107 Q 205 106 206 109 L 208 109.5 L 204 110 L 204 106 L 205.5 106 L 206.5 105 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 121 L 119 124 L 117 123.5 L 118.5 121 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 121 L 128 121.5 L 120.5 122 L 120.5 121 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 121 L 137 122.5 L 135.5 122 L 134.5 121 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 122 L 100.5 124 L 101.5 122 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 123 L 225 123.5 L 216.5 124 L 216.5 123 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 123 L 256 123.5 L 248.5 124 L 248.5 123 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201 128 L 204 128.5 L 204 143.5 Q 206.7 145.3 205 151.5 L 204 152.5 L 204 160 L 200.5 161 L 201 159.5 L 200 144.5 L 201 143.5 L 201 128 Z M 201 144 L 201 152 L 204 152 L 204 144 L 201 144 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 129 L 80 129.5 L 72.5 130 L 72.5 129 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 131 L 81.5 133 L 80.5 131 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 132 L 146.5 135 L 148.5 132 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 132 L 223.5 134 L 216 133.5 L 224.5 132 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 132 L 228.5 134 L 227.5 132 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232 133 L 240 133 L 240 144 L 232 144.5 L 240 145.5 L 231.5 147 L 230 145.5 L 232 141.5 L 232 133 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 133 Q 255.8 132.3 255 134.5 L 253.5 133 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 134 L 80 134.5 L 72.5 135 L 72.5 134 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 134 L 100.5 136 L 99.5 134 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 134 L 215 137.5 L 213 136.5 L 213.5 134 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113 136 L 115 136.5 L 115 160 L 113 159.5 L 113 136 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 137 L 80 137.5 L 77.5 138 L 77.5 137 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 137 L 112 137 L 112 141 L 109 139.5 L 110.5 137 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 137 L 133.5 139 L 132.5 137 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 138 L 75 140.5 L 73.5 142 L 73 139.5 L 74.5 138 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 138 L 186.5 138 L 188 138.5 L 186 139 Q 184.9 141.7 187.5 141 L 187.5 142 L 185.5 141 L 183.5 142 L 183.5 141 Q 185.8 141.8 185 139.5 L 184.5 138 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 139 L 78.5 141 L 77.5 139 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 140 L 213.5 142 L 214.5 140 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 140 L 224 140.5 L 216.5 141 L 216.5 140 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 141 L 151 143.5 L 150.5 152 L 150 143.5 L 149 142.5 L 150.5 141 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 143 L 79.5 145 L 78.5 143 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 144 L 149 152.5 L 150 153.5 L 148 152.5 L 148.5 144 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 144 L 161 159.5 L 160 159.5 L 160 157 L 152.5 157 L 152 155 L 160 155 L 160 151 L 152 150.5 L 160 150 L 160 146 L 152.5 146 L 152.5 145 Q 158.8 146.8 160.5 144 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 144 L 187 144.5 L 184.5 146 L 185.5 144 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 144 L 198 159.5 L 197 159.5 L 197.5 144 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 148 L 75.5 150 L 76.5 148 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 148 L 224 148.5 L 216.5 149 L 216.5 148 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 148 L 228.5 150 L 229.5 148 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 150 L 40 150.5 L 0.5 151 L 0.5 150 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 150 L 240 150.5 L 232.5 151 L 232.5 150 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 152 L 78.5 154 L 77.5 152 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 152 L 174 159.5 L 173 159.5 L 173.5 152 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 152 L 176 159.5 L 175 159.5 L 175.5 152 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 152 L 180.5 154 L 179.5 152 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 155 L 139 155.5 L 136.5 156 L 136.5 155 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 155 Q 148.3 153.8 147 157.5 L 144.5 159 L 144.5 158 Q 147.1 158.7 146 156 L 144.5 155 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 157 L 131 157.5 L 128.5 158 L 128.5 157 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 157 Q 140.1 155.7 139 159 Q 134.9 160.3 136 157 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 158 L 79.5 160 L 78.5 158 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 158 Q 135.1 157.3 134 160 L 131 159.5 L 132.5 158 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 162 L 181 162 L 181 166 L 178 164.5 L 179.5 162 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 169 L 96 169.5 L 88.5 170 L 88.5 169 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,253,252)",
    stroke: "rgb(252,253,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 171 L 88 171.5 L 72.5 172 L 72.5 171 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 16 L 126.5 18 L 127.5 16 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 18 L 82 18.5 L 80 19.5 L 80 18 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 20 L 207 20.5 L 203.5 22 L 204.5 20 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 21 Q 81.3 20.3 82 22.5 L 80.5 22 L 75 24 Q 73.9 21.3 76.5 22 L 77.5 21 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 29 L 67 31.5 L 66 31.5 L 65.5 29 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 29 L 192 31.5 L 191 31.5 L 191.5 29 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 30 L 254 32 L 252 31.5 L 253.5 30 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 32 L 62 33.5 L 61 36 Q 57.2 37.5 58 34.5 L 60 34.5 L 59.5 32 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 36 L 189.5 38 L 190.5 36 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 40 L 188 42.5 L 187 42.5 L 187.5 40 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 44 L 104.5 46 L 105.5 44 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 44 L 172 46.5 L 169 48 L 170.5 44 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52 45 Q 56.5 43.5 55 48 L 52 46.5 L 52 45 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 51 L 180 53.5 L 179 53.5 L 179.5 51 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 53 L 98.5 55 L 99.5 53 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 54 L 109.5 56 L 110.5 54 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 58 L 183 62.5 L 182 62.5 L 182.5 58 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 75 L 178 77.5 L 177 77.5 L 177.5 75 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 80 L 114 81.5 L 112 82.5 L 113.5 80 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 96 L 84 96.5 L 81.5 97 L 81.5 96 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 108 L 76.5 110 L 75.5 108 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 109 L 167.5 111 L 168.5 109 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 110 Q 152.8 109.3 152 111.5 L 150.5 110 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 120 L 51.5 122 L 50.5 120 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 120 L 108 121.5 L 107.5 123 L 107 121.5 L 108.5 120 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 120 L 136.5 122 L 135.5 120 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 122 L 141.5 124 L 142.5 122 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 136 Q 75.5 137.5 72.5 139 L 72.5 136 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 136 L 106 136.5 L 102.5 137 L 102.5 136 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 137 L 170.5 139 L 169.5 137 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 142 L 75 143.5 L 73.5 143 L 72.5 142 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 142 L 112 143.5 L 109.5 144 L 108.5 142 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 144 L 45.5 146 L 46.5 144 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 145 L 60.5 147 L 61.5 145 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 146 L 171.5 148 L 172.5 146 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 150 L 178.5 152 L 177.5 150 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 151 L 138.5 153 L 139.5 151 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 151 L 213 159.5 L 212 159.5 L 212.5 151 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,250,249)",
    stroke: "rgb(249,250,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 152 L 145.5 154 L 144 153.5 L 146.5 152 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 9 L 159.5 9 L 160 11 L 152.5 11 L 152 9 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208 10 L 215.5 10 L 216 12 L 208.5 12 L 208 10 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 10 L 231.5 10 L 232 12 L 224.5 12 L 224 10 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 13 L 159.5 13 L 160 15 L 152.5 15 L 152 13 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 15 L 147 15.5 L 144.5 16 L 144.5 15 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 15 Q 240.8 14.3 240 16.5 L 238.5 15 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 20 L 78 20.5 L 74.5 22 L 74.5 21 L 76.5 20 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 20 Q 150.8 18.9 150 21.5 L 148.5 21 L 147.5 20 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 24 L 64 24.5 L 56.5 25 L 56.5 24 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 24 L 165 24.5 L 160.5 27 L 160.5 26 L 163.5 24 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56 28 L 64 28.5 L 62.5 30 L 56 30 L 56 28 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 29 L 164 30 L 163.5 32 L 160.5 29 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 32 L 64 35.5 L 62 36.5 L 62.5 32 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 32 L 172 34.5 L 171 34.5 L 171.5 32 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 33 L 253 33.5 Q 253.8 35.8 251.5 35 L 250.5 33 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 48 L 182 51.5 L 179 49.5 L 179.5 48 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 49 L 174 52 Q 170.5 53.1 172.5 49 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 53 L 109.5 55 Q 106.7 55.7 108.5 53 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 56 L 42 62.5 L 41 62.5 L 41.5 56 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 56 L 47 62.5 L 46 62.5 L 46.5 56 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 59 L 7.5 59 L 8 61 L 0.5 61 L 0 59 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 59 L 39.5 59 L 40 61 L 32.5 61 L 32 59 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 59 L 255.5 59 L 256 61 L 248.5 61 L 248 59 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280 59 L 287.5 59 L 288 61 L 280.5 61 L 280 59 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 64 L 110 64.5 L 104.5 65 L 104.5 64 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 67 L 113 70.5 L 111 71.5 L 111.5 67 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 69 Q 37.4 67.5 39 70.5 L 36 72.5 L 35.5 75 L 35 72 Q 30.5 73.5 32 69 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 79 L 90.5 81 L 89.5 79 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 79 L 228 81 L 232 80 L 232 83 L 224 83 Q 222.3 78.9 226.5 80 L 227.5 79 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104 80 L 111.5 80 L 113 81.5 L 111.5 83 L 104 83 L 104 80 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 81 L 35 83.5 L 34 83.5 L 34.5 81 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 85 L 91 88.5 L 90 88.5 L 90.5 85 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 88 L 121 92.5 L 118.5 91 Q 115.4 91.7 117.5 88 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 92 L 94 94.5 L 93 94.5 L 93.5 92 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 92 L 218 93.5 L 217.5 96 L 217 93.5 L 218.5 92 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 96 L 85.5 98 L 80.5 99 L 80.5 98 Q 85.1 98.6 86.5 96 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 96 L 115 96.5 L 114.5 99 Q 110.3 100.1 112 96 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 100 L 232.5 101 L 272 101 L 271.5 104 L 232 104 L 231.5 100 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 101 L 8 101 L 8 104 L 0 104 L 0 101 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18 101 Q 21.3 99.9 20 104 Q 16.7 105.1 18 101 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 101 L 112 101.5 L 111 104 L 96.5 104 L 96 101 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280 101 L 288 101 L 288 104 L 280 104 L 280 101 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 102 L 88 102.5 L 85.5 104 L 86.5 102 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 108 L 128 111.5 L 127 111.5 L 127.5 108 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 110 L 204 110.5 L 199.5 111 L 199.5 110 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 112 L 56 112.5 L 48.5 113 L 48.5 112 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 115 L 55.5 115 L 56 117 L 48.5 117 L 48 115 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 119 L 56 119.5 L 48.5 120 L 48.5 119 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 120 L 72 120.5 L 69.5 121 L 69.5 120 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100 120 L 102 120.5 Q 100 125 98 121.5 L 100 121.5 L 100 120 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 120 Q 132.8 119.3 132 121.5 L 130.5 120 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 120 L 138.5 122 L 137.5 120 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 120 L 227.5 122 L 228.5 120 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 121 L 224 121.5 L 216.5 122 L 216.5 121 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 121 L 256 121.5 L 248.5 122 L 248.5 121 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 122 L 163.5 125 L 161 124.5 L 161.5 122 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 122 Q 199.8 121.3 199 123.5 L 197.5 122 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 122 L 231 122.5 L 228.5 124 L 229.5 122 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 123 L 64 123.5 L 56.5 124 L 56.5 123 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 123 L 104.5 125 L 103.5 123 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 124 L 110.5 126 L 111.5 124 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195 124 L 197 124.5 L 195 125.5 L 195 124 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 126 L 112.5 128 L 113.5 126 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 127 L 261.5 129 L 260.5 127 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 128 L 80 128.5 L 71.5 129 L 71.5 128 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 129 L 53 130.5 L 51.5 130 L 49.5 131 L 50.5 129 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 129 L 148 130.5 L 146 131.5 L 147.5 129 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 129 Q 185.1 128.3 184 131 L 181 130.5 L 182.5 129 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 131 L 224 132.5 L 216.5 133 L 215.5 131 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 132 L 240 132.5 L 231.5 133 L 231.5 132 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 134 L 80 135.5 L 76.5 138 L 76.5 136 Q 71 137 71.5 134 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 135 L 100.5 137 L 101.5 135 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 136 L 113 136.5 L 113 159.5 L 112 159.5 L 112 142.5 L 111 141.5 L 112 137 L 109 138.5 L 110 140.5 L 108.5 141 Q 105.8 139.8 108 138.5 L 109.5 136 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 136 L 185.5 138 L 187.5 137 L 187.5 138 L 185.5 139 L 184.5 136 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40 137 L 47.5 137 L 48 139 L 40.5 139 L 40 137 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 137 L 225 137.5 Q 223.3 140.8 216.5 139 L 215.5 137 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 138 L 79 139.5 L 77.5 143 L 77 140.5 L 78.5 138 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 138 L 212.5 140 L 213.5 138 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 140 L 152.5 144 L 160 144.5 L 152 145 L 152 151 L 159.5 151 L 159.5 152 L 151 152 L 151 143.5 Q 148 142.5 149.5 140 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40 141 L 47.5 141 L 48 143 L 40.5 143 L 40 141 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 141 L 188 142.5 L 186.5 143 L 185 142.5 L 184.5 144 L 184 142.5 L 185.5 141 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 143 L 240 144.5 L 232.5 145 L 231.5 143 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 144 L 39.5 144 L 41 145.5 L 39.5 145 L 0.5 145 L 0.5 144 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 144 L 176 145.5 L 174.5 146 L 172.5 144 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 144 L 199 159.5 L 198 159.5 L 198.5 144 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 144 L 288 144.5 L 256.5 145 L 256.5 144 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 148 L 42 151.5 L 39.5 152 L 0 151.5 L 39.5 151 L 41 149.5 L 41.5 148 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 149 L 173.5 151 L 173.5 152 L 170.5 149 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 149 L 224 149 L 224 152 L 216 152 L 216 149 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 151 L 240 151.5 L 232.5 152 L 232.5 151 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 151 L 288 151.5 L 256.5 152 L 256.5 151 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 153 L 152 154.5 L 148 155 L 149.5 159 L 152 159 L 152.5 157 L 160 157 Q 161.7 161.1 157.5 160 L 155.5 160 Q 149.3 158.2 147.5 161 L 144 159.5 L 147 157.5 L 146 154.5 L 148.5 153 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 154 L 95 156.5 L 94 156.5 L 93.5 154 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 155 L 133 155.5 L 128.5 156 L 128.5 155 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139 157 L 141 157.5 L 139 158.5 L 139 157 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 159 L 131 159.5 L 128.5 160 L 128.5 159 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 160 L 253 160.5 L 253 168 L 251 167.5 L 251 160 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 163 L 41 163.5 L 39.5 165 L 32 165 L 32 163 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 164 L 171.5 166 L 172.5 164 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 166 L 67.5 168 L 72 168.5 L 64.5 169 L 65.5 167 L 67.5 166 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 167 L 96 168.5 L 88.5 169 L 87.5 167 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 168 L 56 168.5 L 48.5 169 L 48.5 168 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 168 L 112 168.5 L 104.5 169 L 104.5 168 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 168 L 224 168.5 L 216.5 169 L 216.5 168 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 172 L 55.5 172 L 56 174 L 48.5 174 L 48 172 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 172 L 71.5 172 L 72 174 L 64.5 174 L 64 172 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 172 L 111.5 172 L 112 174 L 96.5 173 L 95.5 174 L 88 174 L 88 172 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216 172 L 223.5 172 L 224 174 L 216.5 174 L 216 172 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,252,252)",
    stroke: "rgb(252,252,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 175 L 104 175.5 L 96.5 176 L 96.5 175 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 16 L 243 18 L 240 17.5 L 242.5 16 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 19 L 110 19.5 L 106.5 20 L 106.5 19 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 60 L 236 60.5 L 233.5 62 L 234.5 60 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 70 L 177 71.5 L 175 72.5 L 176.5 70 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 111 L 54 111.5 L 51.5 112 L 51.5 111 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 111 L 189 111.5 L 186.5 112 L 186.5 111 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 124 L 204.5 126 L 205.5 124 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 128 L 189 136.5 L 188 136.5 L 188.5 128 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 132 L 162 134.5 L 161 134.5 L 161.5 132 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 135 L 95.5 137 L 94.5 135 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 136 L 76 136.5 L 72.5 138 L 73.5 136 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 142 L 109 143.5 L 107.5 143 L 106.5 142 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 148 L 45.5 150 L 44.5 148 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 152 L 140 153.5 L 138.5 154 L 136.5 152 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 153 L 111.5 155 L 110.5 153 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 160 L 230 161.5 L 228.5 161 L 227.5 160 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 162 L 66.5 164 L 67.5 162 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 162 L 158 164 L 156 163.5 L 157.5 162 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,248,249)",
    stroke: "rgb(249,248,249)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 165 L 230.5 167 L 229.5 165 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspNetLogo1);
export default __webpack_public_path__ + "static/media/asp-net-logo1.3078bace3e7c5fbada30b666c6c4b19b.svg";
export { ForwardRef as ReactComponent };